/*eslint-disable*/
(function(global, factory) { /* global define, require, module */

    /* AMD */ if (typeof define === 'function' && define.amd)
        define(["protobufjs/minimal"], factory);

    /* CommonJS */ else if (typeof require === 'function' && typeof module === 'object' && module && module.exports)
        module.exports = factory(require("protobufjs/minimal"));

})(this, function($protobuf) {
    "use strict";

    // Common aliases
    var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
    
    // Exported root namespace
    var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});
    
    $root.density = (function() {
    
        /**
         * Namespace density.
         * @exports density
         * @namespace
         */
        var density = {};
    
        density.protocol = (function() {
    
            /**
             * Namespace protocol.
             * @memberof density
             * @namespace
             */
            var protocol = {};
    
            protocol.openarea = (function() {
    
                /**
                 * Namespace openarea.
                 * @memberof density.protocol
                 * @namespace
                 */
                var openarea = {};
    
                openarea.v1 = (function() {
    
                    /**
                     * Namespace v1.
                     * @memberof density.protocol.openarea
                     * @namespace
                     */
                    var v1 = {};
    
                    v1.Frame = (function() {
    
                        /**
                         * Properties of a Frame.
                         * @memberof density.protocol.openarea.v1
                         * @interface IFrame
                         * @property {boolean|null} [parsed] Frame parsed
                         * @property {number|null} [frameNumber] Frame frameNumber
                         * @property {number|Long|null} [timestamp] Frame timestamp
                         * @property {Array.<density.protocol.openarea.v1.Frame.IMmwavePoint>|null} [pointCloud] Frame pointCloud
                         * @property {Array.<density.protocol.openarea.v1.Frame.IMmwaveAuxiliary>|null} [sideInfo] Frame sideInfo
                         * @property {Array.<number>|null} [rangeProfile_dB] Frame rangeProfile_dB
                         * @property {Array.<number>|null} [noiseProfile_dB] Frame noiseProfile_dB
                         * @property {Array.<number>|null} [rangeDopplerHeatmap_logMag] Frame rangeDopplerHeatmap_logMag
                         * @property {density.protocol.openarea.v1.Frame.ITimingStats|null} [timing] Frame timing
                         * @property {density.protocol.openarea.v1.Frame.ITemperatureData|null} [temperatures] Frame temperatures
                         * @property {density.protocol.openarea.v1.Frame.IClassifier|null} [classifier] Frame classifier
                         * @property {Array.<number>|null} [intraframeData] Frame intraframeData
                         * @property {Array.<density.protocol.openarea.v1.Frame.IMmwavePoint>|null} [pointCloudUnfiltered] Frame pointCloudUnfiltered
                         * @property {Array.<density.protocol.openarea.v1.Frame.IMmwavePoint>|null} [pointCloudIF] Frame pointCloudIF
                         * @property {Array.<density.protocol.openarea.v1.Frame.IMmwaveAuxiliary>|null} [sideInfoIF] Frame sideInfoIF
                         * @property {Array.<number>|null} [rangeDopplerIF] Frame rangeDopplerIF
                         * @property {density.sensors.accelerometer.v1.IAccelerometerData|null} [acceldata] Frame acceldata
                         * @property {boolean|null} [tilt_compensation_active] Frame tilt_compensation_active
                         * @property {density.protocol.openarea.v1.Frame.IChamberData|null} [chamber] Frame chamber
                         */
    
                        /**
                         * Constructs a new Frame.
                         * @memberof density.protocol.openarea.v1
                         * @classdesc Represents a Frame.
                         * @implements IFrame
                         * @constructor
                         * @param {density.protocol.openarea.v1.IFrame=} [properties] Properties to set
                         */
                        function Frame(properties) {
                            this.pointCloud = [];
                            this.sideInfo = [];
                            this.rangeProfile_dB = [];
                            this.noiseProfile_dB = [];
                            this.rangeDopplerHeatmap_logMag = [];
                            this.intraframeData = [];
                            this.pointCloudUnfiltered = [];
                            this.pointCloudIF = [];
                            this.sideInfoIF = [];
                            this.rangeDopplerIF = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Frame parsed.
                         * @member {boolean} parsed
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.parsed = false;
    
                        /**
                         * Frame frameNumber.
                         * @member {number} frameNumber
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.frameNumber = 0;
    
                        /**
                         * Frame timestamp.
                         * @member {number|Long} timestamp
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    
                        /**
                         * Frame pointCloud.
                         * @member {Array.<density.protocol.openarea.v1.Frame.IMmwavePoint>} pointCloud
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.pointCloud = $util.emptyArray;
    
                        /**
                         * Frame sideInfo.
                         * @member {Array.<density.protocol.openarea.v1.Frame.IMmwaveAuxiliary>} sideInfo
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.sideInfo = $util.emptyArray;
    
                        /**
                         * Frame rangeProfile_dB.
                         * @member {Array.<number>} rangeProfile_dB
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.rangeProfile_dB = $util.emptyArray;
    
                        /**
                         * Frame noiseProfile_dB.
                         * @member {Array.<number>} noiseProfile_dB
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.noiseProfile_dB = $util.emptyArray;
    
                        /**
                         * Frame rangeDopplerHeatmap_logMag.
                         * @member {Array.<number>} rangeDopplerHeatmap_logMag
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.rangeDopplerHeatmap_logMag = $util.emptyArray;
    
                        /**
                         * Frame timing.
                         * @member {density.protocol.openarea.v1.Frame.ITimingStats|null|undefined} timing
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.timing = null;
    
                        /**
                         * Frame temperatures.
                         * @member {density.protocol.openarea.v1.Frame.ITemperatureData|null|undefined} temperatures
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.temperatures = null;
    
                        /**
                         * Frame classifier.
                         * @member {density.protocol.openarea.v1.Frame.IClassifier|null|undefined} classifier
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.classifier = null;
    
                        /**
                         * Frame intraframeData.
                         * @member {Array.<number>} intraframeData
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.intraframeData = $util.emptyArray;
    
                        /**
                         * Frame pointCloudUnfiltered.
                         * @member {Array.<density.protocol.openarea.v1.Frame.IMmwavePoint>} pointCloudUnfiltered
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.pointCloudUnfiltered = $util.emptyArray;
    
                        /**
                         * Frame pointCloudIF.
                         * @member {Array.<density.protocol.openarea.v1.Frame.IMmwavePoint>} pointCloudIF
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.pointCloudIF = $util.emptyArray;
    
                        /**
                         * Frame sideInfoIF.
                         * @member {Array.<density.protocol.openarea.v1.Frame.IMmwaveAuxiliary>} sideInfoIF
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.sideInfoIF = $util.emptyArray;
    
                        /**
                         * Frame rangeDopplerIF.
                         * @member {Array.<number>} rangeDopplerIF
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.rangeDopplerIF = $util.emptyArray;
    
                        /**
                         * Frame acceldata.
                         * @member {density.sensors.accelerometer.v1.IAccelerometerData|null|undefined} acceldata
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.acceldata = null;
    
                        /**
                         * Frame tilt_compensation_active.
                         * @member {boolean} tilt_compensation_active
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.tilt_compensation_active = false;
    
                        /**
                         * Frame chamber.
                         * @member {density.protocol.openarea.v1.Frame.IChamberData|null|undefined} chamber
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         */
                        Frame.prototype.chamber = null;
    
                        /**
                         * Creates a new Frame instance using the specified properties.
                         * @function create
                         * @memberof density.protocol.openarea.v1.Frame
                         * @static
                         * @param {density.protocol.openarea.v1.IFrame=} [properties] Properties to set
                         * @returns {density.protocol.openarea.v1.Frame} Frame instance
                         */
                        Frame.create = function create(properties) {
                            return new Frame(properties);
                        };
    
                        /**
                         * Encodes the specified Frame message. Does not implicitly {@link density.protocol.openarea.v1.Frame.verify|verify} messages.
                         * @function encode
                         * @memberof density.protocol.openarea.v1.Frame
                         * @static
                         * @param {density.protocol.openarea.v1.IFrame} message Frame message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Frame.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.pointCloud != null && message.pointCloud.length)
                                for (var i = 0; i < message.pointCloud.length; ++i)
                                    $root.density.protocol.openarea.v1.Frame.MmwavePoint.encode(message.pointCloud[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.rangeProfile_dB != null && message.rangeProfile_dB.length) {
                                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                                for (var i = 0; i < message.rangeProfile_dB.length; ++i)
                                    writer.float(message.rangeProfile_dB[i]);
                                writer.ldelim();
                            }
                            if (message.noiseProfile_dB != null && message.noiseProfile_dB.length) {
                                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                                for (var i = 0; i < message.noiseProfile_dB.length; ++i)
                                    writer.float(message.noiseProfile_dB[i]);
                                writer.ldelim();
                            }
                            if (message.rangeDopplerHeatmap_logMag != null && message.rangeDopplerHeatmap_logMag.length) {
                                writer.uint32(/* id 5, wireType 2 =*/42).fork();
                                for (var i = 0; i < message.rangeDopplerHeatmap_logMag.length; ++i)
                                    writer.float(message.rangeDopplerHeatmap_logMag[i]);
                                writer.ldelim();
                            }
                            if (message.timing != null && Object.hasOwnProperty.call(message, "timing"))
                                $root.density.protocol.openarea.v1.Frame.TimingStats.encode(message.timing, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                            if (message.sideInfo != null && message.sideInfo.length)
                                for (var i = 0; i < message.sideInfo.length; ++i)
                                    $root.density.protocol.openarea.v1.Frame.MmwaveAuxiliary.encode(message.sideInfo[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                            if (message.temperatures != null && Object.hasOwnProperty.call(message, "temperatures"))
                                $root.density.protocol.openarea.v1.Frame.TemperatureData.encode(message.temperatures, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                            if (message.parsed != null && Object.hasOwnProperty.call(message, "parsed"))
                                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.parsed);
                            if (message.frameNumber != null && Object.hasOwnProperty.call(message, "frameNumber"))
                                writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.frameNumber);
                            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                                writer.uint32(/* id 12, wireType 0 =*/96).uint64(message.timestamp);
                            if (message.classifier != null && Object.hasOwnProperty.call(message, "classifier"))
                                $root.density.protocol.openarea.v1.Frame.Classifier.encode(message.classifier, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                            if (message.intraframeData != null && message.intraframeData.length) {
                                writer.uint32(/* id 14, wireType 2 =*/114).fork();
                                for (var i = 0; i < message.intraframeData.length; ++i)
                                    writer.int32(message.intraframeData[i]);
                                writer.ldelim();
                            }
                            if (message.pointCloudUnfiltered != null && message.pointCloudUnfiltered.length)
                                for (var i = 0; i < message.pointCloudUnfiltered.length; ++i)
                                    $root.density.protocol.openarea.v1.Frame.MmwavePoint.encode(message.pointCloudUnfiltered[i], writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                            if (message.chamber != null && Object.hasOwnProperty.call(message, "chamber"))
                                $root.density.protocol.openarea.v1.Frame.ChamberData.encode(message.chamber, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                            if (message.pointCloudIF != null && message.pointCloudIF.length)
                                for (var i = 0; i < message.pointCloudIF.length; ++i)
                                    $root.density.protocol.openarea.v1.Frame.MmwavePoint.encode(message.pointCloudIF[i], writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                            if (message.sideInfoIF != null && message.sideInfoIF.length)
                                for (var i = 0; i < message.sideInfoIF.length; ++i)
                                    $root.density.protocol.openarea.v1.Frame.MmwaveAuxiliary.encode(message.sideInfoIF[i], writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                            if (message.rangeDopplerIF != null && message.rangeDopplerIF.length) {
                                writer.uint32(/* id 22, wireType 2 =*/178).fork();
                                for (var i = 0; i < message.rangeDopplerIF.length; ++i)
                                    writer.float(message.rangeDopplerIF[i]);
                                writer.ldelim();
                            }
                            if (message.acceldata != null && Object.hasOwnProperty.call(message, "acceldata"))
                                $root.density.sensors.accelerometer.v1.AccelerometerData.encode(message.acceldata, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
                            if (message.tilt_compensation_active != null && Object.hasOwnProperty.call(message, "tilt_compensation_active"))
                                writer.uint32(/* id 24, wireType 0 =*/192).bool(message.tilt_compensation_active);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Frame message, length delimited. Does not implicitly {@link density.protocol.openarea.v1.Frame.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof density.protocol.openarea.v1.Frame
                         * @static
                         * @param {density.protocol.openarea.v1.IFrame} message Frame message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Frame.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Frame message from the specified reader or buffer.
                         * @function decode
                         * @memberof density.protocol.openarea.v1.Frame
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {density.protocol.openarea.v1.Frame} Frame
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Frame.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.protocol.openarea.v1.Frame();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 10:
                                    message.parsed = reader.bool();
                                    break;
                                case 11:
                                    message.frameNumber = reader.uint32();
                                    break;
                                case 12:
                                    message.timestamp = reader.uint64();
                                    break;
                                case 1:
                                    if (!(message.pointCloud && message.pointCloud.length))
                                        message.pointCloud = [];
                                    message.pointCloud.push($root.density.protocol.openarea.v1.Frame.MmwavePoint.decode(reader, reader.uint32()));
                                    break;
                                case 7:
                                    if (!(message.sideInfo && message.sideInfo.length))
                                        message.sideInfo = [];
                                    message.sideInfo.push($root.density.protocol.openarea.v1.Frame.MmwaveAuxiliary.decode(reader, reader.uint32()));
                                    break;
                                case 2:
                                    if (!(message.rangeProfile_dB && message.rangeProfile_dB.length))
                                        message.rangeProfile_dB = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.rangeProfile_dB.push(reader.float());
                                    } else
                                        message.rangeProfile_dB.push(reader.float());
                                    break;
                                case 3:
                                    if (!(message.noiseProfile_dB && message.noiseProfile_dB.length))
                                        message.noiseProfile_dB = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.noiseProfile_dB.push(reader.float());
                                    } else
                                        message.noiseProfile_dB.push(reader.float());
                                    break;
                                case 5:
                                    if (!(message.rangeDopplerHeatmap_logMag && message.rangeDopplerHeatmap_logMag.length))
                                        message.rangeDopplerHeatmap_logMag = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.rangeDopplerHeatmap_logMag.push(reader.float());
                                    } else
                                        message.rangeDopplerHeatmap_logMag.push(reader.float());
                                    break;
                                case 6:
                                    message.timing = $root.density.protocol.openarea.v1.Frame.TimingStats.decode(reader, reader.uint32());
                                    break;
                                case 9:
                                    message.temperatures = $root.density.protocol.openarea.v1.Frame.TemperatureData.decode(reader, reader.uint32());
                                    break;
                                case 13:
                                    message.classifier = $root.density.protocol.openarea.v1.Frame.Classifier.decode(reader, reader.uint32());
                                    break;
                                case 14:
                                    if (!(message.intraframeData && message.intraframeData.length))
                                        message.intraframeData = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.intraframeData.push(reader.int32());
                                    } else
                                        message.intraframeData.push(reader.int32());
                                    break;
                                case 15:
                                    if (!(message.pointCloudUnfiltered && message.pointCloudUnfiltered.length))
                                        message.pointCloudUnfiltered = [];
                                    message.pointCloudUnfiltered.push($root.density.protocol.openarea.v1.Frame.MmwavePoint.decode(reader, reader.uint32()));
                                    break;
                                case 20:
                                    if (!(message.pointCloudIF && message.pointCloudIF.length))
                                        message.pointCloudIF = [];
                                    message.pointCloudIF.push($root.density.protocol.openarea.v1.Frame.MmwavePoint.decode(reader, reader.uint32()));
                                    break;
                                case 21:
                                    if (!(message.sideInfoIF && message.sideInfoIF.length))
                                        message.sideInfoIF = [];
                                    message.sideInfoIF.push($root.density.protocol.openarea.v1.Frame.MmwaveAuxiliary.decode(reader, reader.uint32()));
                                    break;
                                case 22:
                                    if (!(message.rangeDopplerIF && message.rangeDopplerIF.length))
                                        message.rangeDopplerIF = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.rangeDopplerIF.push(reader.float());
                                    } else
                                        message.rangeDopplerIF.push(reader.float());
                                    break;
                                case 23:
                                    message.acceldata = $root.density.sensors.accelerometer.v1.AccelerometerData.decode(reader, reader.uint32());
                                    break;
                                case 24:
                                    message.tilt_compensation_active = reader.bool();
                                    break;
                                case 16:
                                    message.chamber = $root.density.protocol.openarea.v1.Frame.ChamberData.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Frame message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof density.protocol.openarea.v1.Frame
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {density.protocol.openarea.v1.Frame} Frame
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Frame.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Frame message.
                         * @function verify
                         * @memberof density.protocol.openarea.v1.Frame
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Frame.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.parsed != null && message.hasOwnProperty("parsed"))
                                if (typeof message.parsed !== "boolean")
                                    return "parsed: boolean expected";
                            if (message.frameNumber != null && message.hasOwnProperty("frameNumber"))
                                if (!$util.isInteger(message.frameNumber))
                                    return "frameNumber: integer expected";
                            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                                    return "timestamp: integer|Long expected";
                            if (message.pointCloud != null && message.hasOwnProperty("pointCloud")) {
                                if (!Array.isArray(message.pointCloud))
                                    return "pointCloud: array expected";
                                for (var i = 0; i < message.pointCloud.length; ++i) {
                                    var error = $root.density.protocol.openarea.v1.Frame.MmwavePoint.verify(message.pointCloud[i]);
                                    if (error)
                                        return "pointCloud." + error;
                                }
                            }
                            if (message.sideInfo != null && message.hasOwnProperty("sideInfo")) {
                                if (!Array.isArray(message.sideInfo))
                                    return "sideInfo: array expected";
                                for (var i = 0; i < message.sideInfo.length; ++i) {
                                    var error = $root.density.protocol.openarea.v1.Frame.MmwaveAuxiliary.verify(message.sideInfo[i]);
                                    if (error)
                                        return "sideInfo." + error;
                                }
                            }
                            if (message.rangeProfile_dB != null && message.hasOwnProperty("rangeProfile_dB")) {
                                if (!Array.isArray(message.rangeProfile_dB))
                                    return "rangeProfile_dB: array expected";
                                for (var i = 0; i < message.rangeProfile_dB.length; ++i)
                                    if (typeof message.rangeProfile_dB[i] !== "number")
                                        return "rangeProfile_dB: number[] expected";
                            }
                            if (message.noiseProfile_dB != null && message.hasOwnProperty("noiseProfile_dB")) {
                                if (!Array.isArray(message.noiseProfile_dB))
                                    return "noiseProfile_dB: array expected";
                                for (var i = 0; i < message.noiseProfile_dB.length; ++i)
                                    if (typeof message.noiseProfile_dB[i] !== "number")
                                        return "noiseProfile_dB: number[] expected";
                            }
                            if (message.rangeDopplerHeatmap_logMag != null && message.hasOwnProperty("rangeDopplerHeatmap_logMag")) {
                                if (!Array.isArray(message.rangeDopplerHeatmap_logMag))
                                    return "rangeDopplerHeatmap_logMag: array expected";
                                for (var i = 0; i < message.rangeDopplerHeatmap_logMag.length; ++i)
                                    if (typeof message.rangeDopplerHeatmap_logMag[i] !== "number")
                                        return "rangeDopplerHeatmap_logMag: number[] expected";
                            }
                            if (message.timing != null && message.hasOwnProperty("timing")) {
                                var error = $root.density.protocol.openarea.v1.Frame.TimingStats.verify(message.timing);
                                if (error)
                                    return "timing." + error;
                            }
                            if (message.temperatures != null && message.hasOwnProperty("temperatures")) {
                                var error = $root.density.protocol.openarea.v1.Frame.TemperatureData.verify(message.temperatures);
                                if (error)
                                    return "temperatures." + error;
                            }
                            if (message.classifier != null && message.hasOwnProperty("classifier")) {
                                var error = $root.density.protocol.openarea.v1.Frame.Classifier.verify(message.classifier);
                                if (error)
                                    return "classifier." + error;
                            }
                            if (message.intraframeData != null && message.hasOwnProperty("intraframeData")) {
                                if (!Array.isArray(message.intraframeData))
                                    return "intraframeData: array expected";
                                for (var i = 0; i < message.intraframeData.length; ++i)
                                    if (!$util.isInteger(message.intraframeData[i]))
                                        return "intraframeData: integer[] expected";
                            }
                            if (message.pointCloudUnfiltered != null && message.hasOwnProperty("pointCloudUnfiltered")) {
                                if (!Array.isArray(message.pointCloudUnfiltered))
                                    return "pointCloudUnfiltered: array expected";
                                for (var i = 0; i < message.pointCloudUnfiltered.length; ++i) {
                                    var error = $root.density.protocol.openarea.v1.Frame.MmwavePoint.verify(message.pointCloudUnfiltered[i]);
                                    if (error)
                                        return "pointCloudUnfiltered." + error;
                                }
                            }
                            if (message.pointCloudIF != null && message.hasOwnProperty("pointCloudIF")) {
                                if (!Array.isArray(message.pointCloudIF))
                                    return "pointCloudIF: array expected";
                                for (var i = 0; i < message.pointCloudIF.length; ++i) {
                                    var error = $root.density.protocol.openarea.v1.Frame.MmwavePoint.verify(message.pointCloudIF[i]);
                                    if (error)
                                        return "pointCloudIF." + error;
                                }
                            }
                            if (message.sideInfoIF != null && message.hasOwnProperty("sideInfoIF")) {
                                if (!Array.isArray(message.sideInfoIF))
                                    return "sideInfoIF: array expected";
                                for (var i = 0; i < message.sideInfoIF.length; ++i) {
                                    var error = $root.density.protocol.openarea.v1.Frame.MmwaveAuxiliary.verify(message.sideInfoIF[i]);
                                    if (error)
                                        return "sideInfoIF." + error;
                                }
                            }
                            if (message.rangeDopplerIF != null && message.hasOwnProperty("rangeDopplerIF")) {
                                if (!Array.isArray(message.rangeDopplerIF))
                                    return "rangeDopplerIF: array expected";
                                for (var i = 0; i < message.rangeDopplerIF.length; ++i)
                                    if (typeof message.rangeDopplerIF[i] !== "number")
                                        return "rangeDopplerIF: number[] expected";
                            }
                            if (message.acceldata != null && message.hasOwnProperty("acceldata")) {
                                var error = $root.density.sensors.accelerometer.v1.AccelerometerData.verify(message.acceldata);
                                if (error)
                                    return "acceldata." + error;
                            }
                            if (message.tilt_compensation_active != null && message.hasOwnProperty("tilt_compensation_active"))
                                if (typeof message.tilt_compensation_active !== "boolean")
                                    return "tilt_compensation_active: boolean expected";
                            if (message.chamber != null && message.hasOwnProperty("chamber")) {
                                var error = $root.density.protocol.openarea.v1.Frame.ChamberData.verify(message.chamber);
                                if (error)
                                    return "chamber." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a Frame message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof density.protocol.openarea.v1.Frame
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {density.protocol.openarea.v1.Frame} Frame
                         */
                        Frame.fromObject = function fromObject(object) {
                            if (object instanceof $root.density.protocol.openarea.v1.Frame)
                                return object;
                            var message = new $root.density.protocol.openarea.v1.Frame();
                            if (object.parsed != null)
                                message.parsed = Boolean(object.parsed);
                            if (object.frameNumber != null)
                                message.frameNumber = object.frameNumber >>> 0;
                            if (object.timestamp != null)
                                if ($util.Long)
                                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                                else if (typeof object.timestamp === "string")
                                    message.timestamp = parseInt(object.timestamp, 10);
                                else if (typeof object.timestamp === "number")
                                    message.timestamp = object.timestamp;
                                else if (typeof object.timestamp === "object")
                                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
                            if (object.pointCloud) {
                                if (!Array.isArray(object.pointCloud))
                                    throw TypeError(".density.protocol.openarea.v1.Frame.pointCloud: array expected");
                                message.pointCloud = [];
                                for (var i = 0; i < object.pointCloud.length; ++i) {
                                    if (typeof object.pointCloud[i] !== "object")
                                        throw TypeError(".density.protocol.openarea.v1.Frame.pointCloud: object expected");
                                    message.pointCloud[i] = $root.density.protocol.openarea.v1.Frame.MmwavePoint.fromObject(object.pointCloud[i]);
                                }
                            }
                            if (object.sideInfo) {
                                if (!Array.isArray(object.sideInfo))
                                    throw TypeError(".density.protocol.openarea.v1.Frame.sideInfo: array expected");
                                message.sideInfo = [];
                                for (var i = 0; i < object.sideInfo.length; ++i) {
                                    if (typeof object.sideInfo[i] !== "object")
                                        throw TypeError(".density.protocol.openarea.v1.Frame.sideInfo: object expected");
                                    message.sideInfo[i] = $root.density.protocol.openarea.v1.Frame.MmwaveAuxiliary.fromObject(object.sideInfo[i]);
                                }
                            }
                            if (object.rangeProfile_dB) {
                                if (!Array.isArray(object.rangeProfile_dB))
                                    throw TypeError(".density.protocol.openarea.v1.Frame.rangeProfile_dB: array expected");
                                message.rangeProfile_dB = [];
                                for (var i = 0; i < object.rangeProfile_dB.length; ++i)
                                    message.rangeProfile_dB[i] = Number(object.rangeProfile_dB[i]);
                            }
                            if (object.noiseProfile_dB) {
                                if (!Array.isArray(object.noiseProfile_dB))
                                    throw TypeError(".density.protocol.openarea.v1.Frame.noiseProfile_dB: array expected");
                                message.noiseProfile_dB = [];
                                for (var i = 0; i < object.noiseProfile_dB.length; ++i)
                                    message.noiseProfile_dB[i] = Number(object.noiseProfile_dB[i]);
                            }
                            if (object.rangeDopplerHeatmap_logMag) {
                                if (!Array.isArray(object.rangeDopplerHeatmap_logMag))
                                    throw TypeError(".density.protocol.openarea.v1.Frame.rangeDopplerHeatmap_logMag: array expected");
                                message.rangeDopplerHeatmap_logMag = [];
                                for (var i = 0; i < object.rangeDopplerHeatmap_logMag.length; ++i)
                                    message.rangeDopplerHeatmap_logMag[i] = Number(object.rangeDopplerHeatmap_logMag[i]);
                            }
                            if (object.timing != null) {
                                if (typeof object.timing !== "object")
                                    throw TypeError(".density.protocol.openarea.v1.Frame.timing: object expected");
                                message.timing = $root.density.protocol.openarea.v1.Frame.TimingStats.fromObject(object.timing);
                            }
                            if (object.temperatures != null) {
                                if (typeof object.temperatures !== "object")
                                    throw TypeError(".density.protocol.openarea.v1.Frame.temperatures: object expected");
                                message.temperatures = $root.density.protocol.openarea.v1.Frame.TemperatureData.fromObject(object.temperatures);
                            }
                            if (object.classifier != null) {
                                if (typeof object.classifier !== "object")
                                    throw TypeError(".density.protocol.openarea.v1.Frame.classifier: object expected");
                                message.classifier = $root.density.protocol.openarea.v1.Frame.Classifier.fromObject(object.classifier);
                            }
                            if (object.intraframeData) {
                                if (!Array.isArray(object.intraframeData))
                                    throw TypeError(".density.protocol.openarea.v1.Frame.intraframeData: array expected");
                                message.intraframeData = [];
                                for (var i = 0; i < object.intraframeData.length; ++i)
                                    message.intraframeData[i] = object.intraframeData[i] | 0;
                            }
                            if (object.pointCloudUnfiltered) {
                                if (!Array.isArray(object.pointCloudUnfiltered))
                                    throw TypeError(".density.protocol.openarea.v1.Frame.pointCloudUnfiltered: array expected");
                                message.pointCloudUnfiltered = [];
                                for (var i = 0; i < object.pointCloudUnfiltered.length; ++i) {
                                    if (typeof object.pointCloudUnfiltered[i] !== "object")
                                        throw TypeError(".density.protocol.openarea.v1.Frame.pointCloudUnfiltered: object expected");
                                    message.pointCloudUnfiltered[i] = $root.density.protocol.openarea.v1.Frame.MmwavePoint.fromObject(object.pointCloudUnfiltered[i]);
                                }
                            }
                            if (object.pointCloudIF) {
                                if (!Array.isArray(object.pointCloudIF))
                                    throw TypeError(".density.protocol.openarea.v1.Frame.pointCloudIF: array expected");
                                message.pointCloudIF = [];
                                for (var i = 0; i < object.pointCloudIF.length; ++i) {
                                    if (typeof object.pointCloudIF[i] !== "object")
                                        throw TypeError(".density.protocol.openarea.v1.Frame.pointCloudIF: object expected");
                                    message.pointCloudIF[i] = $root.density.protocol.openarea.v1.Frame.MmwavePoint.fromObject(object.pointCloudIF[i]);
                                }
                            }
                            if (object.sideInfoIF) {
                                if (!Array.isArray(object.sideInfoIF))
                                    throw TypeError(".density.protocol.openarea.v1.Frame.sideInfoIF: array expected");
                                message.sideInfoIF = [];
                                for (var i = 0; i < object.sideInfoIF.length; ++i) {
                                    if (typeof object.sideInfoIF[i] !== "object")
                                        throw TypeError(".density.protocol.openarea.v1.Frame.sideInfoIF: object expected");
                                    message.sideInfoIF[i] = $root.density.protocol.openarea.v1.Frame.MmwaveAuxiliary.fromObject(object.sideInfoIF[i]);
                                }
                            }
                            if (object.rangeDopplerIF) {
                                if (!Array.isArray(object.rangeDopplerIF))
                                    throw TypeError(".density.protocol.openarea.v1.Frame.rangeDopplerIF: array expected");
                                message.rangeDopplerIF = [];
                                for (var i = 0; i < object.rangeDopplerIF.length; ++i)
                                    message.rangeDopplerIF[i] = Number(object.rangeDopplerIF[i]);
                            }
                            if (object.acceldata != null) {
                                if (typeof object.acceldata !== "object")
                                    throw TypeError(".density.protocol.openarea.v1.Frame.acceldata: object expected");
                                message.acceldata = $root.density.sensors.accelerometer.v1.AccelerometerData.fromObject(object.acceldata);
                            }
                            if (object.tilt_compensation_active != null)
                                message.tilt_compensation_active = Boolean(object.tilt_compensation_active);
                            if (object.chamber != null) {
                                if (typeof object.chamber !== "object")
                                    throw TypeError(".density.protocol.openarea.v1.Frame.chamber: object expected");
                                message.chamber = $root.density.protocol.openarea.v1.Frame.ChamberData.fromObject(object.chamber);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Frame message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof density.protocol.openarea.v1.Frame
                         * @static
                         * @param {density.protocol.openarea.v1.Frame} message Frame
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Frame.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.pointCloud = [];
                                object.rangeProfile_dB = [];
                                object.noiseProfile_dB = [];
                                object.rangeDopplerHeatmap_logMag = [];
                                object.sideInfo = [];
                                object.intraframeData = [];
                                object.pointCloudUnfiltered = [];
                                object.pointCloudIF = [];
                                object.sideInfoIF = [];
                                object.rangeDopplerIF = [];
                            }
                            if (options.defaults) {
                                object.timing = null;
                                object.temperatures = null;
                                object.parsed = false;
                                object.frameNumber = 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, true);
                                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.timestamp = options.longs === String ? "0" : 0;
                                object.classifier = null;
                                object.chamber = null;
                                object.acceldata = null;
                                object.tilt_compensation_active = false;
                            }
                            if (message.pointCloud && message.pointCloud.length) {
                                object.pointCloud = [];
                                for (var j = 0; j < message.pointCloud.length; ++j)
                                    object.pointCloud[j] = $root.density.protocol.openarea.v1.Frame.MmwavePoint.toObject(message.pointCloud[j], options);
                            }
                            if (message.rangeProfile_dB && message.rangeProfile_dB.length) {
                                object.rangeProfile_dB = [];
                                for (var j = 0; j < message.rangeProfile_dB.length; ++j)
                                    object.rangeProfile_dB[j] = options.json && !isFinite(message.rangeProfile_dB[j]) ? String(message.rangeProfile_dB[j]) : message.rangeProfile_dB[j];
                            }
                            if (message.noiseProfile_dB && message.noiseProfile_dB.length) {
                                object.noiseProfile_dB = [];
                                for (var j = 0; j < message.noiseProfile_dB.length; ++j)
                                    object.noiseProfile_dB[j] = options.json && !isFinite(message.noiseProfile_dB[j]) ? String(message.noiseProfile_dB[j]) : message.noiseProfile_dB[j];
                            }
                            if (message.rangeDopplerHeatmap_logMag && message.rangeDopplerHeatmap_logMag.length) {
                                object.rangeDopplerHeatmap_logMag = [];
                                for (var j = 0; j < message.rangeDopplerHeatmap_logMag.length; ++j)
                                    object.rangeDopplerHeatmap_logMag[j] = options.json && !isFinite(message.rangeDopplerHeatmap_logMag[j]) ? String(message.rangeDopplerHeatmap_logMag[j]) : message.rangeDopplerHeatmap_logMag[j];
                            }
                            if (message.timing != null && message.hasOwnProperty("timing"))
                                object.timing = $root.density.protocol.openarea.v1.Frame.TimingStats.toObject(message.timing, options);
                            if (message.sideInfo && message.sideInfo.length) {
                                object.sideInfo = [];
                                for (var j = 0; j < message.sideInfo.length; ++j)
                                    object.sideInfo[j] = $root.density.protocol.openarea.v1.Frame.MmwaveAuxiliary.toObject(message.sideInfo[j], options);
                            }
                            if (message.temperatures != null && message.hasOwnProperty("temperatures"))
                                object.temperatures = $root.density.protocol.openarea.v1.Frame.TemperatureData.toObject(message.temperatures, options);
                            if (message.parsed != null && message.hasOwnProperty("parsed"))
                                object.parsed = message.parsed;
                            if (message.frameNumber != null && message.hasOwnProperty("frameNumber"))
                                object.frameNumber = message.frameNumber;
                            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                                if (typeof message.timestamp === "number")
                                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                                else
                                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
                            if (message.classifier != null && message.hasOwnProperty("classifier"))
                                object.classifier = $root.density.protocol.openarea.v1.Frame.Classifier.toObject(message.classifier, options);
                            if (message.intraframeData && message.intraframeData.length) {
                                object.intraframeData = [];
                                for (var j = 0; j < message.intraframeData.length; ++j)
                                    object.intraframeData[j] = message.intraframeData[j];
                            }
                            if (message.pointCloudUnfiltered && message.pointCloudUnfiltered.length) {
                                object.pointCloudUnfiltered = [];
                                for (var j = 0; j < message.pointCloudUnfiltered.length; ++j)
                                    object.pointCloudUnfiltered[j] = $root.density.protocol.openarea.v1.Frame.MmwavePoint.toObject(message.pointCloudUnfiltered[j], options);
                            }
                            if (message.chamber != null && message.hasOwnProperty("chamber"))
                                object.chamber = $root.density.protocol.openarea.v1.Frame.ChamberData.toObject(message.chamber, options);
                            if (message.pointCloudIF && message.pointCloudIF.length) {
                                object.pointCloudIF = [];
                                for (var j = 0; j < message.pointCloudIF.length; ++j)
                                    object.pointCloudIF[j] = $root.density.protocol.openarea.v1.Frame.MmwavePoint.toObject(message.pointCloudIF[j], options);
                            }
                            if (message.sideInfoIF && message.sideInfoIF.length) {
                                object.sideInfoIF = [];
                                for (var j = 0; j < message.sideInfoIF.length; ++j)
                                    object.sideInfoIF[j] = $root.density.protocol.openarea.v1.Frame.MmwaveAuxiliary.toObject(message.sideInfoIF[j], options);
                            }
                            if (message.rangeDopplerIF && message.rangeDopplerIF.length) {
                                object.rangeDopplerIF = [];
                                for (var j = 0; j < message.rangeDopplerIF.length; ++j)
                                    object.rangeDopplerIF[j] = options.json && !isFinite(message.rangeDopplerIF[j]) ? String(message.rangeDopplerIF[j]) : message.rangeDopplerIF[j];
                            }
                            if (message.acceldata != null && message.hasOwnProperty("acceldata"))
                                object.acceldata = $root.density.sensors.accelerometer.v1.AccelerometerData.toObject(message.acceldata, options);
                            if (message.tilt_compensation_active != null && message.hasOwnProperty("tilt_compensation_active"))
                                object.tilt_compensation_active = message.tilt_compensation_active;
                            return object;
                        };
    
                        /**
                         * Converts this Frame to JSON.
                         * @function toJSON
                         * @memberof density.protocol.openarea.v1.Frame
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Frame.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        Frame.MmwavePoint = (function() {
    
                            /**
                             * Properties of a MmwavePoint.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @interface IMmwavePoint
                             * @property {number|null} [x] MmwavePoint x
                             * @property {number|null} [y] MmwavePoint y
                             * @property {number|null} [z] MmwavePoint z
                             * @property {number|null} [velocity] MmwavePoint velocity
                             */
    
                            /**
                             * Constructs a new MmwavePoint.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @classdesc Represents a MmwavePoint.
                             * @implements IMmwavePoint
                             * @constructor
                             * @param {density.protocol.openarea.v1.Frame.IMmwavePoint=} [properties] Properties to set
                             */
                            function MmwavePoint(properties) {
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * MmwavePoint x.
                             * @member {number} x
                             * @memberof density.protocol.openarea.v1.Frame.MmwavePoint
                             * @instance
                             */
                            MmwavePoint.prototype.x = 0;
    
                            /**
                             * MmwavePoint y.
                             * @member {number} y
                             * @memberof density.protocol.openarea.v1.Frame.MmwavePoint
                             * @instance
                             */
                            MmwavePoint.prototype.y = 0;
    
                            /**
                             * MmwavePoint z.
                             * @member {number} z
                             * @memberof density.protocol.openarea.v1.Frame.MmwavePoint
                             * @instance
                             */
                            MmwavePoint.prototype.z = 0;
    
                            /**
                             * MmwavePoint velocity.
                             * @member {number} velocity
                             * @memberof density.protocol.openarea.v1.Frame.MmwavePoint
                             * @instance
                             */
                            MmwavePoint.prototype.velocity = 0;
    
                            /**
                             * Creates a new MmwavePoint instance using the specified properties.
                             * @function create
                             * @memberof density.protocol.openarea.v1.Frame.MmwavePoint
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.IMmwavePoint=} [properties] Properties to set
                             * @returns {density.protocol.openarea.v1.Frame.MmwavePoint} MmwavePoint instance
                             */
                            MmwavePoint.create = function create(properties) {
                                return new MmwavePoint(properties);
                            };
    
                            /**
                             * Encodes the specified MmwavePoint message. Does not implicitly {@link density.protocol.openarea.v1.Frame.MmwavePoint.verify|verify} messages.
                             * @function encode
                             * @memberof density.protocol.openarea.v1.Frame.MmwavePoint
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.IMmwavePoint} message MmwavePoint message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            MmwavePoint.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                                    writer.uint32(/* id 1, wireType 5 =*/13).float(message.x);
                                if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                                    writer.uint32(/* id 2, wireType 5 =*/21).float(message.y);
                                if (message.z != null && Object.hasOwnProperty.call(message, "z"))
                                    writer.uint32(/* id 3, wireType 5 =*/29).float(message.z);
                                if (message.velocity != null && Object.hasOwnProperty.call(message, "velocity"))
                                    writer.uint32(/* id 4, wireType 5 =*/37).float(message.velocity);
                                return writer;
                            };
    
                            /**
                             * Encodes the specified MmwavePoint message, length delimited. Does not implicitly {@link density.protocol.openarea.v1.Frame.MmwavePoint.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.MmwavePoint
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.IMmwavePoint} message MmwavePoint message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            MmwavePoint.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a MmwavePoint message from the specified reader or buffer.
                             * @function decode
                             * @memberof density.protocol.openarea.v1.Frame.MmwavePoint
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {density.protocol.openarea.v1.Frame.MmwavePoint} MmwavePoint
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            MmwavePoint.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.protocol.openarea.v1.Frame.MmwavePoint();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1:
                                        message.x = reader.float();
                                        break;
                                    case 2:
                                        message.y = reader.float();
                                        break;
                                    case 3:
                                        message.z = reader.float();
                                        break;
                                    case 4:
                                        message.velocity = reader.float();
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a MmwavePoint message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.MmwavePoint
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {density.protocol.openarea.v1.Frame.MmwavePoint} MmwavePoint
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            MmwavePoint.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a MmwavePoint message.
                             * @function verify
                             * @memberof density.protocol.openarea.v1.Frame.MmwavePoint
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            MmwavePoint.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.x != null && message.hasOwnProperty("x"))
                                    if (typeof message.x !== "number")
                                        return "x: number expected";
                                if (message.y != null && message.hasOwnProperty("y"))
                                    if (typeof message.y !== "number")
                                        return "y: number expected";
                                if (message.z != null && message.hasOwnProperty("z"))
                                    if (typeof message.z !== "number")
                                        return "z: number expected";
                                if (message.velocity != null && message.hasOwnProperty("velocity"))
                                    if (typeof message.velocity !== "number")
                                        return "velocity: number expected";
                                return null;
                            };
    
                            /**
                             * Creates a MmwavePoint message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof density.protocol.openarea.v1.Frame.MmwavePoint
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {density.protocol.openarea.v1.Frame.MmwavePoint} MmwavePoint
                             */
                            MmwavePoint.fromObject = function fromObject(object) {
                                if (object instanceof $root.density.protocol.openarea.v1.Frame.MmwavePoint)
                                    return object;
                                var message = new $root.density.protocol.openarea.v1.Frame.MmwavePoint();
                                if (object.x != null)
                                    message.x = Number(object.x);
                                if (object.y != null)
                                    message.y = Number(object.y);
                                if (object.z != null)
                                    message.z = Number(object.z);
                                if (object.velocity != null)
                                    message.velocity = Number(object.velocity);
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a MmwavePoint message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof density.protocol.openarea.v1.Frame.MmwavePoint
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.MmwavePoint} message MmwavePoint
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            MmwavePoint.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.defaults) {
                                    object.x = 0;
                                    object.y = 0;
                                    object.z = 0;
                                    object.velocity = 0;
                                }
                                if (message.x != null && message.hasOwnProperty("x"))
                                    object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
                                if (message.y != null && message.hasOwnProperty("y"))
                                    object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
                                if (message.z != null && message.hasOwnProperty("z"))
                                    object.z = options.json && !isFinite(message.z) ? String(message.z) : message.z;
                                if (message.velocity != null && message.hasOwnProperty("velocity"))
                                    object.velocity = options.json && !isFinite(message.velocity) ? String(message.velocity) : message.velocity;
                                return object;
                            };
    
                            /**
                             * Converts this MmwavePoint to JSON.
                             * @function toJSON
                             * @memberof density.protocol.openarea.v1.Frame.MmwavePoint
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            MmwavePoint.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return MmwavePoint;
                        })();
    
                        Frame.MmwaveAuxiliary = (function() {
    
                            /**
                             * Properties of a MmwaveAuxiliary.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @interface IMmwaveAuxiliary
                             * @property {number|null} [snr] MmwaveAuxiliary snr
                             * @property {number|null} [noise] MmwaveAuxiliary noise
                             */
    
                            /**
                             * Constructs a new MmwaveAuxiliary.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @classdesc Represents a MmwaveAuxiliary.
                             * @implements IMmwaveAuxiliary
                             * @constructor
                             * @param {density.protocol.openarea.v1.Frame.IMmwaveAuxiliary=} [properties] Properties to set
                             */
                            function MmwaveAuxiliary(properties) {
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * MmwaveAuxiliary snr.
                             * @member {number} snr
                             * @memberof density.protocol.openarea.v1.Frame.MmwaveAuxiliary
                             * @instance
                             */
                            MmwaveAuxiliary.prototype.snr = 0;
    
                            /**
                             * MmwaveAuxiliary noise.
                             * @member {number} noise
                             * @memberof density.protocol.openarea.v1.Frame.MmwaveAuxiliary
                             * @instance
                             */
                            MmwaveAuxiliary.prototype.noise = 0;
    
                            /**
                             * Creates a new MmwaveAuxiliary instance using the specified properties.
                             * @function create
                             * @memberof density.protocol.openarea.v1.Frame.MmwaveAuxiliary
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.IMmwaveAuxiliary=} [properties] Properties to set
                             * @returns {density.protocol.openarea.v1.Frame.MmwaveAuxiliary} MmwaveAuxiliary instance
                             */
                            MmwaveAuxiliary.create = function create(properties) {
                                return new MmwaveAuxiliary(properties);
                            };
    
                            /**
                             * Encodes the specified MmwaveAuxiliary message. Does not implicitly {@link density.protocol.openarea.v1.Frame.MmwaveAuxiliary.verify|verify} messages.
                             * @function encode
                             * @memberof density.protocol.openarea.v1.Frame.MmwaveAuxiliary
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.IMmwaveAuxiliary} message MmwaveAuxiliary message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            MmwaveAuxiliary.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.snr != null && Object.hasOwnProperty.call(message, "snr"))
                                    writer.uint32(/* id 1, wireType 5 =*/13).float(message.snr);
                                if (message.noise != null && Object.hasOwnProperty.call(message, "noise"))
                                    writer.uint32(/* id 2, wireType 5 =*/21).float(message.noise);
                                return writer;
                            };
    
                            /**
                             * Encodes the specified MmwaveAuxiliary message, length delimited. Does not implicitly {@link density.protocol.openarea.v1.Frame.MmwaveAuxiliary.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.MmwaveAuxiliary
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.IMmwaveAuxiliary} message MmwaveAuxiliary message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            MmwaveAuxiliary.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a MmwaveAuxiliary message from the specified reader or buffer.
                             * @function decode
                             * @memberof density.protocol.openarea.v1.Frame.MmwaveAuxiliary
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {density.protocol.openarea.v1.Frame.MmwaveAuxiliary} MmwaveAuxiliary
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            MmwaveAuxiliary.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.protocol.openarea.v1.Frame.MmwaveAuxiliary();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1:
                                        message.snr = reader.float();
                                        break;
                                    case 2:
                                        message.noise = reader.float();
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a MmwaveAuxiliary message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.MmwaveAuxiliary
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {density.protocol.openarea.v1.Frame.MmwaveAuxiliary} MmwaveAuxiliary
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            MmwaveAuxiliary.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a MmwaveAuxiliary message.
                             * @function verify
                             * @memberof density.protocol.openarea.v1.Frame.MmwaveAuxiliary
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            MmwaveAuxiliary.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.snr != null && message.hasOwnProperty("snr"))
                                    if (typeof message.snr !== "number")
                                        return "snr: number expected";
                                if (message.noise != null && message.hasOwnProperty("noise"))
                                    if (typeof message.noise !== "number")
                                        return "noise: number expected";
                                return null;
                            };
    
                            /**
                             * Creates a MmwaveAuxiliary message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof density.protocol.openarea.v1.Frame.MmwaveAuxiliary
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {density.protocol.openarea.v1.Frame.MmwaveAuxiliary} MmwaveAuxiliary
                             */
                            MmwaveAuxiliary.fromObject = function fromObject(object) {
                                if (object instanceof $root.density.protocol.openarea.v1.Frame.MmwaveAuxiliary)
                                    return object;
                                var message = new $root.density.protocol.openarea.v1.Frame.MmwaveAuxiliary();
                                if (object.snr != null)
                                    message.snr = Number(object.snr);
                                if (object.noise != null)
                                    message.noise = Number(object.noise);
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a MmwaveAuxiliary message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof density.protocol.openarea.v1.Frame.MmwaveAuxiliary
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.MmwaveAuxiliary} message MmwaveAuxiliary
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            MmwaveAuxiliary.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.defaults) {
                                    object.snr = 0;
                                    object.noise = 0;
                                }
                                if (message.snr != null && message.hasOwnProperty("snr"))
                                    object.snr = options.json && !isFinite(message.snr) ? String(message.snr) : message.snr;
                                if (message.noise != null && message.hasOwnProperty("noise"))
                                    object.noise = options.json && !isFinite(message.noise) ? String(message.noise) : message.noise;
                                return object;
                            };
    
                            /**
                             * Converts this MmwaveAuxiliary to JSON.
                             * @function toJSON
                             * @memberof density.protocol.openarea.v1.Frame.MmwaveAuxiliary
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            MmwaveAuxiliary.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return MmwaveAuxiliary;
                        })();
    
                        Frame.TimingStats = (function() {
    
                            /**
                             * Properties of a TimingStats.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @interface ITimingStats
                             * @property {number|null} [interFrameProcessingTime] TimingStats interFrameProcessingTime
                             * @property {number|null} [transmitOutputTime] TimingStats transmitOutputTime
                             * @property {number|null} [interFrameProcessingMargin] TimingStats interFrameProcessingMargin
                             * @property {number|null} [interChirpProcessingMargin] TimingStats interChirpProcessingMargin
                             * @property {number|null} [activeFrameCPULoad] TimingStats activeFrameCPULoad
                             * @property {number|null} [interFrameCPULoad] TimingStats interFrameCPULoad
                             */
    
                            /**
                             * Constructs a new TimingStats.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @classdesc Represents a TimingStats.
                             * @implements ITimingStats
                             * @constructor
                             * @param {density.protocol.openarea.v1.Frame.ITimingStats=} [properties] Properties to set
                             */
                            function TimingStats(properties) {
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * TimingStats interFrameProcessingTime.
                             * @member {number} interFrameProcessingTime
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @instance
                             */
                            TimingStats.prototype.interFrameProcessingTime = 0;
    
                            /**
                             * TimingStats transmitOutputTime.
                             * @member {number} transmitOutputTime
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @instance
                             */
                            TimingStats.prototype.transmitOutputTime = 0;
    
                            /**
                             * TimingStats interFrameProcessingMargin.
                             * @member {number} interFrameProcessingMargin
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @instance
                             */
                            TimingStats.prototype.interFrameProcessingMargin = 0;
    
                            /**
                             * TimingStats interChirpProcessingMargin.
                             * @member {number} interChirpProcessingMargin
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @instance
                             */
                            TimingStats.prototype.interChirpProcessingMargin = 0;
    
                            /**
                             * TimingStats activeFrameCPULoad.
                             * @member {number} activeFrameCPULoad
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @instance
                             */
                            TimingStats.prototype.activeFrameCPULoad = 0;
    
                            /**
                             * TimingStats interFrameCPULoad.
                             * @member {number} interFrameCPULoad
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @instance
                             */
                            TimingStats.prototype.interFrameCPULoad = 0;
    
                            /**
                             * Creates a new TimingStats instance using the specified properties.
                             * @function create
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.ITimingStats=} [properties] Properties to set
                             * @returns {density.protocol.openarea.v1.Frame.TimingStats} TimingStats instance
                             */
                            TimingStats.create = function create(properties) {
                                return new TimingStats(properties);
                            };
    
                            /**
                             * Encodes the specified TimingStats message. Does not implicitly {@link density.protocol.openarea.v1.Frame.TimingStats.verify|verify} messages.
                             * @function encode
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.ITimingStats} message TimingStats message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            TimingStats.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.interFrameProcessingTime != null && Object.hasOwnProperty.call(message, "interFrameProcessingTime"))
                                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.interFrameProcessingTime);
                                if (message.transmitOutputTime != null && Object.hasOwnProperty.call(message, "transmitOutputTime"))
                                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.transmitOutputTime);
                                if (message.interFrameProcessingMargin != null && Object.hasOwnProperty.call(message, "interFrameProcessingMargin"))
                                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.interFrameProcessingMargin);
                                if (message.interChirpProcessingMargin != null && Object.hasOwnProperty.call(message, "interChirpProcessingMargin"))
                                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.interChirpProcessingMargin);
                                if (message.activeFrameCPULoad != null && Object.hasOwnProperty.call(message, "activeFrameCPULoad"))
                                    writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.activeFrameCPULoad);
                                if (message.interFrameCPULoad != null && Object.hasOwnProperty.call(message, "interFrameCPULoad"))
                                    writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.interFrameCPULoad);
                                return writer;
                            };
    
                            /**
                             * Encodes the specified TimingStats message, length delimited. Does not implicitly {@link density.protocol.openarea.v1.Frame.TimingStats.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.ITimingStats} message TimingStats message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            TimingStats.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a TimingStats message from the specified reader or buffer.
                             * @function decode
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {density.protocol.openarea.v1.Frame.TimingStats} TimingStats
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            TimingStats.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.protocol.openarea.v1.Frame.TimingStats();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1:
                                        message.interFrameProcessingTime = reader.uint32();
                                        break;
                                    case 2:
                                        message.transmitOutputTime = reader.uint32();
                                        break;
                                    case 3:
                                        message.interFrameProcessingMargin = reader.uint32();
                                        break;
                                    case 4:
                                        message.interChirpProcessingMargin = reader.uint32();
                                        break;
                                    case 5:
                                        message.activeFrameCPULoad = reader.uint32();
                                        break;
                                    case 6:
                                        message.interFrameCPULoad = reader.uint32();
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a TimingStats message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {density.protocol.openarea.v1.Frame.TimingStats} TimingStats
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            TimingStats.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a TimingStats message.
                             * @function verify
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            TimingStats.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.interFrameProcessingTime != null && message.hasOwnProperty("interFrameProcessingTime"))
                                    if (!$util.isInteger(message.interFrameProcessingTime))
                                        return "interFrameProcessingTime: integer expected";
                                if (message.transmitOutputTime != null && message.hasOwnProperty("transmitOutputTime"))
                                    if (!$util.isInteger(message.transmitOutputTime))
                                        return "transmitOutputTime: integer expected";
                                if (message.interFrameProcessingMargin != null && message.hasOwnProperty("interFrameProcessingMargin"))
                                    if (!$util.isInteger(message.interFrameProcessingMargin))
                                        return "interFrameProcessingMargin: integer expected";
                                if (message.interChirpProcessingMargin != null && message.hasOwnProperty("interChirpProcessingMargin"))
                                    if (!$util.isInteger(message.interChirpProcessingMargin))
                                        return "interChirpProcessingMargin: integer expected";
                                if (message.activeFrameCPULoad != null && message.hasOwnProperty("activeFrameCPULoad"))
                                    if (!$util.isInteger(message.activeFrameCPULoad))
                                        return "activeFrameCPULoad: integer expected";
                                if (message.interFrameCPULoad != null && message.hasOwnProperty("interFrameCPULoad"))
                                    if (!$util.isInteger(message.interFrameCPULoad))
                                        return "interFrameCPULoad: integer expected";
                                return null;
                            };
    
                            /**
                             * Creates a TimingStats message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {density.protocol.openarea.v1.Frame.TimingStats} TimingStats
                             */
                            TimingStats.fromObject = function fromObject(object) {
                                if (object instanceof $root.density.protocol.openarea.v1.Frame.TimingStats)
                                    return object;
                                var message = new $root.density.protocol.openarea.v1.Frame.TimingStats();
                                if (object.interFrameProcessingTime != null)
                                    message.interFrameProcessingTime = object.interFrameProcessingTime >>> 0;
                                if (object.transmitOutputTime != null)
                                    message.transmitOutputTime = object.transmitOutputTime >>> 0;
                                if (object.interFrameProcessingMargin != null)
                                    message.interFrameProcessingMargin = object.interFrameProcessingMargin >>> 0;
                                if (object.interChirpProcessingMargin != null)
                                    message.interChirpProcessingMargin = object.interChirpProcessingMargin >>> 0;
                                if (object.activeFrameCPULoad != null)
                                    message.activeFrameCPULoad = object.activeFrameCPULoad >>> 0;
                                if (object.interFrameCPULoad != null)
                                    message.interFrameCPULoad = object.interFrameCPULoad >>> 0;
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a TimingStats message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.TimingStats} message TimingStats
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            TimingStats.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.defaults) {
                                    object.interFrameProcessingTime = 0;
                                    object.transmitOutputTime = 0;
                                    object.interFrameProcessingMargin = 0;
                                    object.interChirpProcessingMargin = 0;
                                    object.activeFrameCPULoad = 0;
                                    object.interFrameCPULoad = 0;
                                }
                                if (message.interFrameProcessingTime != null && message.hasOwnProperty("interFrameProcessingTime"))
                                    object.interFrameProcessingTime = message.interFrameProcessingTime;
                                if (message.transmitOutputTime != null && message.hasOwnProperty("transmitOutputTime"))
                                    object.transmitOutputTime = message.transmitOutputTime;
                                if (message.interFrameProcessingMargin != null && message.hasOwnProperty("interFrameProcessingMargin"))
                                    object.interFrameProcessingMargin = message.interFrameProcessingMargin;
                                if (message.interChirpProcessingMargin != null && message.hasOwnProperty("interChirpProcessingMargin"))
                                    object.interChirpProcessingMargin = message.interChirpProcessingMargin;
                                if (message.activeFrameCPULoad != null && message.hasOwnProperty("activeFrameCPULoad"))
                                    object.activeFrameCPULoad = message.activeFrameCPULoad;
                                if (message.interFrameCPULoad != null && message.hasOwnProperty("interFrameCPULoad"))
                                    object.interFrameCPULoad = message.interFrameCPULoad;
                                return object;
                            };
    
                            /**
                             * Converts this TimingStats to JSON.
                             * @function toJSON
                             * @memberof density.protocol.openarea.v1.Frame.TimingStats
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            TimingStats.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return TimingStats;
                        })();
    
                        Frame.TemperatureData = (function() {
    
                            /**
                             * Properties of a TemperatureData.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @interface ITemperatureData
                             * @property {number|null} [tempReportValid] TemperatureData tempReportValid
                             * @property {number|null} [time] TemperatureData time
                             * @property {number|null} [tmpRx0Sens] TemperatureData tmpRx0Sens
                             * @property {number|null} [tmpRx1Sens] TemperatureData tmpRx1Sens
                             * @property {number|null} [tmpRx2Sens] TemperatureData tmpRx2Sens
                             * @property {number|null} [tmpRx3Sens] TemperatureData tmpRx3Sens
                             * @property {number|null} [tmpTx0Sens] TemperatureData tmpTx0Sens
                             * @property {number|null} [tmpTx1Sens] TemperatureData tmpTx1Sens
                             * @property {number|null} [tmpTx2Sens] TemperatureData tmpTx2Sens
                             * @property {number|null} [tmpPmSens] TemperatureData tmpPmSens
                             * @property {number|null} [tmpDig0Sens] TemperatureData tmpDig0Sens
                             * @property {number|null} [tmpDig1Sens] TemperatureData tmpDig1Sens
                             */
    
                            /**
                             * Constructs a new TemperatureData.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @classdesc Represents a TemperatureData.
                             * @implements ITemperatureData
                             * @constructor
                             * @param {density.protocol.openarea.v1.Frame.ITemperatureData=} [properties] Properties to set
                             */
                            function TemperatureData(properties) {
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * TemperatureData tempReportValid.
                             * @member {number} tempReportValid
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @instance
                             */
                            TemperatureData.prototype.tempReportValid = 0;
    
                            /**
                             * TemperatureData time.
                             * @member {number} time
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @instance
                             */
                            TemperatureData.prototype.time = 0;
    
                            /**
                             * TemperatureData tmpRx0Sens.
                             * @member {number} tmpRx0Sens
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @instance
                             */
                            TemperatureData.prototype.tmpRx0Sens = 0;
    
                            /**
                             * TemperatureData tmpRx1Sens.
                             * @member {number} tmpRx1Sens
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @instance
                             */
                            TemperatureData.prototype.tmpRx1Sens = 0;
    
                            /**
                             * TemperatureData tmpRx2Sens.
                             * @member {number} tmpRx2Sens
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @instance
                             */
                            TemperatureData.prototype.tmpRx2Sens = 0;
    
                            /**
                             * TemperatureData tmpRx3Sens.
                             * @member {number} tmpRx3Sens
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @instance
                             */
                            TemperatureData.prototype.tmpRx3Sens = 0;
    
                            /**
                             * TemperatureData tmpTx0Sens.
                             * @member {number} tmpTx0Sens
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @instance
                             */
                            TemperatureData.prototype.tmpTx0Sens = 0;
    
                            /**
                             * TemperatureData tmpTx1Sens.
                             * @member {number} tmpTx1Sens
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @instance
                             */
                            TemperatureData.prototype.tmpTx1Sens = 0;
    
                            /**
                             * TemperatureData tmpTx2Sens.
                             * @member {number} tmpTx2Sens
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @instance
                             */
                            TemperatureData.prototype.tmpTx2Sens = 0;
    
                            /**
                             * TemperatureData tmpPmSens.
                             * @member {number} tmpPmSens
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @instance
                             */
                            TemperatureData.prototype.tmpPmSens = 0;
    
                            /**
                             * TemperatureData tmpDig0Sens.
                             * @member {number} tmpDig0Sens
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @instance
                             */
                            TemperatureData.prototype.tmpDig0Sens = 0;
    
                            /**
                             * TemperatureData tmpDig1Sens.
                             * @member {number} tmpDig1Sens
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @instance
                             */
                            TemperatureData.prototype.tmpDig1Sens = 0;
    
                            /**
                             * Creates a new TemperatureData instance using the specified properties.
                             * @function create
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.ITemperatureData=} [properties] Properties to set
                             * @returns {density.protocol.openarea.v1.Frame.TemperatureData} TemperatureData instance
                             */
                            TemperatureData.create = function create(properties) {
                                return new TemperatureData(properties);
                            };
    
                            /**
                             * Encodes the specified TemperatureData message. Does not implicitly {@link density.protocol.openarea.v1.Frame.TemperatureData.verify|verify} messages.
                             * @function encode
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.ITemperatureData} message TemperatureData message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            TemperatureData.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.tempReportValid != null && Object.hasOwnProperty.call(message, "tempReportValid"))
                                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.tempReportValid);
                                if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.time);
                                if (message.tmpRx0Sens != null && Object.hasOwnProperty.call(message, "tmpRx0Sens"))
                                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.tmpRx0Sens);
                                if (message.tmpRx1Sens != null && Object.hasOwnProperty.call(message, "tmpRx1Sens"))
                                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.tmpRx1Sens);
                                if (message.tmpRx2Sens != null && Object.hasOwnProperty.call(message, "tmpRx2Sens"))
                                    writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.tmpRx2Sens);
                                if (message.tmpRx3Sens != null && Object.hasOwnProperty.call(message, "tmpRx3Sens"))
                                    writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.tmpRx3Sens);
                                if (message.tmpTx0Sens != null && Object.hasOwnProperty.call(message, "tmpTx0Sens"))
                                    writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.tmpTx0Sens);
                                if (message.tmpTx1Sens != null && Object.hasOwnProperty.call(message, "tmpTx1Sens"))
                                    writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.tmpTx1Sens);
                                if (message.tmpTx2Sens != null && Object.hasOwnProperty.call(message, "tmpTx2Sens"))
                                    writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.tmpTx2Sens);
                                if (message.tmpPmSens != null && Object.hasOwnProperty.call(message, "tmpPmSens"))
                                    writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.tmpPmSens);
                                if (message.tmpDig0Sens != null && Object.hasOwnProperty.call(message, "tmpDig0Sens"))
                                    writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.tmpDig0Sens);
                                if (message.tmpDig1Sens != null && Object.hasOwnProperty.call(message, "tmpDig1Sens"))
                                    writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.tmpDig1Sens);
                                return writer;
                            };
    
                            /**
                             * Encodes the specified TemperatureData message, length delimited. Does not implicitly {@link density.protocol.openarea.v1.Frame.TemperatureData.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.ITemperatureData} message TemperatureData message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            TemperatureData.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a TemperatureData message from the specified reader or buffer.
                             * @function decode
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {density.protocol.openarea.v1.Frame.TemperatureData} TemperatureData
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            TemperatureData.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.protocol.openarea.v1.Frame.TemperatureData();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1:
                                        message.tempReportValid = reader.uint32();
                                        break;
                                    case 2:
                                        message.time = reader.uint32();
                                        break;
                                    case 3:
                                        message.tmpRx0Sens = reader.uint32();
                                        break;
                                    case 4:
                                        message.tmpRx1Sens = reader.uint32();
                                        break;
                                    case 5:
                                        message.tmpRx2Sens = reader.uint32();
                                        break;
                                    case 6:
                                        message.tmpRx3Sens = reader.uint32();
                                        break;
                                    case 7:
                                        message.tmpTx0Sens = reader.uint32();
                                        break;
                                    case 8:
                                        message.tmpTx1Sens = reader.uint32();
                                        break;
                                    case 9:
                                        message.tmpTx2Sens = reader.uint32();
                                        break;
                                    case 10:
                                        message.tmpPmSens = reader.uint32();
                                        break;
                                    case 11:
                                        message.tmpDig0Sens = reader.uint32();
                                        break;
                                    case 12:
                                        message.tmpDig1Sens = reader.uint32();
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a TemperatureData message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {density.protocol.openarea.v1.Frame.TemperatureData} TemperatureData
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            TemperatureData.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a TemperatureData message.
                             * @function verify
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            TemperatureData.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.tempReportValid != null && message.hasOwnProperty("tempReportValid"))
                                    if (!$util.isInteger(message.tempReportValid))
                                        return "tempReportValid: integer expected";
                                if (message.time != null && message.hasOwnProperty("time"))
                                    if (!$util.isInteger(message.time))
                                        return "time: integer expected";
                                if (message.tmpRx0Sens != null && message.hasOwnProperty("tmpRx0Sens"))
                                    if (!$util.isInteger(message.tmpRx0Sens))
                                        return "tmpRx0Sens: integer expected";
                                if (message.tmpRx1Sens != null && message.hasOwnProperty("tmpRx1Sens"))
                                    if (!$util.isInteger(message.tmpRx1Sens))
                                        return "tmpRx1Sens: integer expected";
                                if (message.tmpRx2Sens != null && message.hasOwnProperty("tmpRx2Sens"))
                                    if (!$util.isInteger(message.tmpRx2Sens))
                                        return "tmpRx2Sens: integer expected";
                                if (message.tmpRx3Sens != null && message.hasOwnProperty("tmpRx3Sens"))
                                    if (!$util.isInteger(message.tmpRx3Sens))
                                        return "tmpRx3Sens: integer expected";
                                if (message.tmpTx0Sens != null && message.hasOwnProperty("tmpTx0Sens"))
                                    if (!$util.isInteger(message.tmpTx0Sens))
                                        return "tmpTx0Sens: integer expected";
                                if (message.tmpTx1Sens != null && message.hasOwnProperty("tmpTx1Sens"))
                                    if (!$util.isInteger(message.tmpTx1Sens))
                                        return "tmpTx1Sens: integer expected";
                                if (message.tmpTx2Sens != null && message.hasOwnProperty("tmpTx2Sens"))
                                    if (!$util.isInteger(message.tmpTx2Sens))
                                        return "tmpTx2Sens: integer expected";
                                if (message.tmpPmSens != null && message.hasOwnProperty("tmpPmSens"))
                                    if (!$util.isInteger(message.tmpPmSens))
                                        return "tmpPmSens: integer expected";
                                if (message.tmpDig0Sens != null && message.hasOwnProperty("tmpDig0Sens"))
                                    if (!$util.isInteger(message.tmpDig0Sens))
                                        return "tmpDig0Sens: integer expected";
                                if (message.tmpDig1Sens != null && message.hasOwnProperty("tmpDig1Sens"))
                                    if (!$util.isInteger(message.tmpDig1Sens))
                                        return "tmpDig1Sens: integer expected";
                                return null;
                            };
    
                            /**
                             * Creates a TemperatureData message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {density.protocol.openarea.v1.Frame.TemperatureData} TemperatureData
                             */
                            TemperatureData.fromObject = function fromObject(object) {
                                if (object instanceof $root.density.protocol.openarea.v1.Frame.TemperatureData)
                                    return object;
                                var message = new $root.density.protocol.openarea.v1.Frame.TemperatureData();
                                if (object.tempReportValid != null)
                                    message.tempReportValid = object.tempReportValid >>> 0;
                                if (object.time != null)
                                    message.time = object.time >>> 0;
                                if (object.tmpRx0Sens != null)
                                    message.tmpRx0Sens = object.tmpRx0Sens >>> 0;
                                if (object.tmpRx1Sens != null)
                                    message.tmpRx1Sens = object.tmpRx1Sens >>> 0;
                                if (object.tmpRx2Sens != null)
                                    message.tmpRx2Sens = object.tmpRx2Sens >>> 0;
                                if (object.tmpRx3Sens != null)
                                    message.tmpRx3Sens = object.tmpRx3Sens >>> 0;
                                if (object.tmpTx0Sens != null)
                                    message.tmpTx0Sens = object.tmpTx0Sens >>> 0;
                                if (object.tmpTx1Sens != null)
                                    message.tmpTx1Sens = object.tmpTx1Sens >>> 0;
                                if (object.tmpTx2Sens != null)
                                    message.tmpTx2Sens = object.tmpTx2Sens >>> 0;
                                if (object.tmpPmSens != null)
                                    message.tmpPmSens = object.tmpPmSens >>> 0;
                                if (object.tmpDig0Sens != null)
                                    message.tmpDig0Sens = object.tmpDig0Sens >>> 0;
                                if (object.tmpDig1Sens != null)
                                    message.tmpDig1Sens = object.tmpDig1Sens >>> 0;
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a TemperatureData message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.TemperatureData} message TemperatureData
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            TemperatureData.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.defaults) {
                                    object.tempReportValid = 0;
                                    object.time = 0;
                                    object.tmpRx0Sens = 0;
                                    object.tmpRx1Sens = 0;
                                    object.tmpRx2Sens = 0;
                                    object.tmpRx3Sens = 0;
                                    object.tmpTx0Sens = 0;
                                    object.tmpTx1Sens = 0;
                                    object.tmpTx2Sens = 0;
                                    object.tmpPmSens = 0;
                                    object.tmpDig0Sens = 0;
                                    object.tmpDig1Sens = 0;
                                }
                                if (message.tempReportValid != null && message.hasOwnProperty("tempReportValid"))
                                    object.tempReportValid = message.tempReportValid;
                                if (message.time != null && message.hasOwnProperty("time"))
                                    object.time = message.time;
                                if (message.tmpRx0Sens != null && message.hasOwnProperty("tmpRx0Sens"))
                                    object.tmpRx0Sens = message.tmpRx0Sens;
                                if (message.tmpRx1Sens != null && message.hasOwnProperty("tmpRx1Sens"))
                                    object.tmpRx1Sens = message.tmpRx1Sens;
                                if (message.tmpRx2Sens != null && message.hasOwnProperty("tmpRx2Sens"))
                                    object.tmpRx2Sens = message.tmpRx2Sens;
                                if (message.tmpRx3Sens != null && message.hasOwnProperty("tmpRx3Sens"))
                                    object.tmpRx3Sens = message.tmpRx3Sens;
                                if (message.tmpTx0Sens != null && message.hasOwnProperty("tmpTx0Sens"))
                                    object.tmpTx0Sens = message.tmpTx0Sens;
                                if (message.tmpTx1Sens != null && message.hasOwnProperty("tmpTx1Sens"))
                                    object.tmpTx1Sens = message.tmpTx1Sens;
                                if (message.tmpTx2Sens != null && message.hasOwnProperty("tmpTx2Sens"))
                                    object.tmpTx2Sens = message.tmpTx2Sens;
                                if (message.tmpPmSens != null && message.hasOwnProperty("tmpPmSens"))
                                    object.tmpPmSens = message.tmpPmSens;
                                if (message.tmpDig0Sens != null && message.hasOwnProperty("tmpDig0Sens"))
                                    object.tmpDig0Sens = message.tmpDig0Sens;
                                if (message.tmpDig1Sens != null && message.hasOwnProperty("tmpDig1Sens"))
                                    object.tmpDig1Sens = message.tmpDig1Sens;
                                return object;
                            };
    
                            /**
                             * Converts this TemperatureData to JSON.
                             * @function toJSON
                             * @memberof density.protocol.openarea.v1.Frame.TemperatureData
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            TemperatureData.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return TemperatureData;
                        })();
    
                        Frame.Classifier = (function() {
    
                            /**
                             * Properties of a Classifier.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @interface IClassifier
                             * @property {Array.<number>|null} [indices] Classifier indices
                             * @property {Array.<boolean>|null} [occupancy] Classifier occupancy
                             * @property {number|null} [count] Classifier count
                             * @property {Array.<density.protocol.openarea.v1.Frame.ITarget>|null} [targets] Classifier targets
                             */
    
                            /**
                             * Constructs a new Classifier.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @classdesc Represents a Classifier.
                             * @implements IClassifier
                             * @constructor
                             * @param {density.protocol.openarea.v1.Frame.IClassifier=} [properties] Properties to set
                             */
                            function Classifier(properties) {
                                this.indices = [];
                                this.occupancy = [];
                                this.targets = [];
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * Classifier indices.
                             * @member {Array.<number>} indices
                             * @memberof density.protocol.openarea.v1.Frame.Classifier
                             * @instance
                             */
                            Classifier.prototype.indices = $util.emptyArray;
    
                            /**
                             * Classifier occupancy.
                             * @member {Array.<boolean>} occupancy
                             * @memberof density.protocol.openarea.v1.Frame.Classifier
                             * @instance
                             */
                            Classifier.prototype.occupancy = $util.emptyArray;
    
                            /**
                             * Classifier count.
                             * @member {number} count
                             * @memberof density.protocol.openarea.v1.Frame.Classifier
                             * @instance
                             */
                            Classifier.prototype.count = 0;
    
                            /**
                             * Classifier targets.
                             * @member {Array.<density.protocol.openarea.v1.Frame.ITarget>} targets
                             * @memberof density.protocol.openarea.v1.Frame.Classifier
                             * @instance
                             */
                            Classifier.prototype.targets = $util.emptyArray;
    
                            /**
                             * Creates a new Classifier instance using the specified properties.
                             * @function create
                             * @memberof density.protocol.openarea.v1.Frame.Classifier
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.IClassifier=} [properties] Properties to set
                             * @returns {density.protocol.openarea.v1.Frame.Classifier} Classifier instance
                             */
                            Classifier.create = function create(properties) {
                                return new Classifier(properties);
                            };
    
                            /**
                             * Encodes the specified Classifier message. Does not implicitly {@link density.protocol.openarea.v1.Frame.Classifier.verify|verify} messages.
                             * @function encode
                             * @memberof density.protocol.openarea.v1.Frame.Classifier
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.IClassifier} message Classifier message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            Classifier.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.indices != null && message.indices.length) {
                                    writer.uint32(/* id 1, wireType 2 =*/10).fork();
                                    for (var i = 0; i < message.indices.length; ++i)
                                        writer.uint32(message.indices[i]);
                                    writer.ldelim();
                                }
                                if (message.occupancy != null && message.occupancy.length) {
                                    writer.uint32(/* id 2, wireType 2 =*/18).fork();
                                    for (var i = 0; i < message.occupancy.length; ++i)
                                        writer.bool(message.occupancy[i]);
                                    writer.ldelim();
                                }
                                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.count);
                                if (message.targets != null && message.targets.length)
                                    for (var i = 0; i < message.targets.length; ++i)
                                        $root.density.protocol.openarea.v1.Frame.Target.encode(message.targets[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                                return writer;
                            };
    
                            /**
                             * Encodes the specified Classifier message, length delimited. Does not implicitly {@link density.protocol.openarea.v1.Frame.Classifier.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.Classifier
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.IClassifier} message Classifier message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            Classifier.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a Classifier message from the specified reader or buffer.
                             * @function decode
                             * @memberof density.protocol.openarea.v1.Frame.Classifier
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {density.protocol.openarea.v1.Frame.Classifier} Classifier
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            Classifier.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.protocol.openarea.v1.Frame.Classifier();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1:
                                        if (!(message.indices && message.indices.length))
                                            message.indices = [];
                                        if ((tag & 7) === 2) {
                                            var end2 = reader.uint32() + reader.pos;
                                            while (reader.pos < end2)
                                                message.indices.push(reader.uint32());
                                        } else
                                            message.indices.push(reader.uint32());
                                        break;
                                    case 2:
                                        if (!(message.occupancy && message.occupancy.length))
                                            message.occupancy = [];
                                        if ((tag & 7) === 2) {
                                            var end2 = reader.uint32() + reader.pos;
                                            while (reader.pos < end2)
                                                message.occupancy.push(reader.bool());
                                        } else
                                            message.occupancy.push(reader.bool());
                                        break;
                                    case 3:
                                        message.count = reader.uint32();
                                        break;
                                    case 10:
                                        if (!(message.targets && message.targets.length))
                                            message.targets = [];
                                        message.targets.push($root.density.protocol.openarea.v1.Frame.Target.decode(reader, reader.uint32()));
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a Classifier message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.Classifier
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {density.protocol.openarea.v1.Frame.Classifier} Classifier
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            Classifier.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a Classifier message.
                             * @function verify
                             * @memberof density.protocol.openarea.v1.Frame.Classifier
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            Classifier.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.indices != null && message.hasOwnProperty("indices")) {
                                    if (!Array.isArray(message.indices))
                                        return "indices: array expected";
                                    for (var i = 0; i < message.indices.length; ++i)
                                        if (!$util.isInteger(message.indices[i]))
                                            return "indices: integer[] expected";
                                }
                                if (message.occupancy != null && message.hasOwnProperty("occupancy")) {
                                    if (!Array.isArray(message.occupancy))
                                        return "occupancy: array expected";
                                    for (var i = 0; i < message.occupancy.length; ++i)
                                        if (typeof message.occupancy[i] !== "boolean")
                                            return "occupancy: boolean[] expected";
                                }
                                if (message.count != null && message.hasOwnProperty("count"))
                                    if (!$util.isInteger(message.count))
                                        return "count: integer expected";
                                if (message.targets != null && message.hasOwnProperty("targets")) {
                                    if (!Array.isArray(message.targets))
                                        return "targets: array expected";
                                    for (var i = 0; i < message.targets.length; ++i) {
                                        var error = $root.density.protocol.openarea.v1.Frame.Target.verify(message.targets[i]);
                                        if (error)
                                            return "targets." + error;
                                    }
                                }
                                return null;
                            };
    
                            /**
                             * Creates a Classifier message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof density.protocol.openarea.v1.Frame.Classifier
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {density.protocol.openarea.v1.Frame.Classifier} Classifier
                             */
                            Classifier.fromObject = function fromObject(object) {
                                if (object instanceof $root.density.protocol.openarea.v1.Frame.Classifier)
                                    return object;
                                var message = new $root.density.protocol.openarea.v1.Frame.Classifier();
                                if (object.indices) {
                                    if (!Array.isArray(object.indices))
                                        throw TypeError(".density.protocol.openarea.v1.Frame.Classifier.indices: array expected");
                                    message.indices = [];
                                    for (var i = 0; i < object.indices.length; ++i)
                                        message.indices[i] = object.indices[i] >>> 0;
                                }
                                if (object.occupancy) {
                                    if (!Array.isArray(object.occupancy))
                                        throw TypeError(".density.protocol.openarea.v1.Frame.Classifier.occupancy: array expected");
                                    message.occupancy = [];
                                    for (var i = 0; i < object.occupancy.length; ++i)
                                        message.occupancy[i] = Boolean(object.occupancy[i]);
                                }
                                if (object.count != null)
                                    message.count = object.count >>> 0;
                                if (object.targets) {
                                    if (!Array.isArray(object.targets))
                                        throw TypeError(".density.protocol.openarea.v1.Frame.Classifier.targets: array expected");
                                    message.targets = [];
                                    for (var i = 0; i < object.targets.length; ++i) {
                                        if (typeof object.targets[i] !== "object")
                                            throw TypeError(".density.protocol.openarea.v1.Frame.Classifier.targets: object expected");
                                        message.targets[i] = $root.density.protocol.openarea.v1.Frame.Target.fromObject(object.targets[i]);
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a Classifier message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof density.protocol.openarea.v1.Frame.Classifier
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.Classifier} message Classifier
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            Classifier.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.arrays || options.defaults) {
                                    object.indices = [];
                                    object.occupancy = [];
                                    object.targets = [];
                                }
                                if (options.defaults)
                                    object.count = 0;
                                if (message.indices && message.indices.length) {
                                    object.indices = [];
                                    for (var j = 0; j < message.indices.length; ++j)
                                        object.indices[j] = message.indices[j];
                                }
                                if (message.occupancy && message.occupancy.length) {
                                    object.occupancy = [];
                                    for (var j = 0; j < message.occupancy.length; ++j)
                                        object.occupancy[j] = message.occupancy[j];
                                }
                                if (message.count != null && message.hasOwnProperty("count"))
                                    object.count = message.count;
                                if (message.targets && message.targets.length) {
                                    object.targets = [];
                                    for (var j = 0; j < message.targets.length; ++j)
                                        object.targets[j] = $root.density.protocol.openarea.v1.Frame.Target.toObject(message.targets[j], options);
                                }
                                return object;
                            };
    
                            /**
                             * Converts this Classifier to JSON.
                             * @function toJSON
                             * @memberof density.protocol.openarea.v1.Frame.Classifier
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            Classifier.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return Classifier;
                        })();
    
                        Frame.Target = (function() {
    
                            /**
                             * Properties of a Target.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @interface ITarget
                             * @property {number|null} [id] Target id
                             * @property {number|null} [x] Target x
                             * @property {number|null} [y] Target y
                             * @property {number|null} [velX] Target velX
                             * @property {number|null} [velY] Target velY
                             * @property {number|null} [accX] Target accX
                             * @property {number|null} [accY] Target accY
                             * @property {number|null} [tag] Target tag
                             * @property {number|null} [confidence] Target confidence
                             * @property {number|null} [isStatic] Target isStatic
                             */
    
                            /**
                             * Constructs a new Target.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @classdesc Represents a Target.
                             * @implements ITarget
                             * @constructor
                             * @param {density.protocol.openarea.v1.Frame.ITarget=} [properties] Properties to set
                             */
                            function Target(properties) {
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * Target id.
                             * @member {number} id
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @instance
                             */
                            Target.prototype.id = 0;
    
                            /**
                             * Target x.
                             * @member {number} x
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @instance
                             */
                            Target.prototype.x = 0;
    
                            /**
                             * Target y.
                             * @member {number} y
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @instance
                             */
                            Target.prototype.y = 0;
    
                            /**
                             * Target velX.
                             * @member {number} velX
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @instance
                             */
                            Target.prototype.velX = 0;
    
                            /**
                             * Target velY.
                             * @member {number} velY
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @instance
                             */
                            Target.prototype.velY = 0;
    
                            /**
                             * Target accX.
                             * @member {number} accX
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @instance
                             */
                            Target.prototype.accX = 0;
    
                            /**
                             * Target accY.
                             * @member {number} accY
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @instance
                             */
                            Target.prototype.accY = 0;
    
                            /**
                             * Target tag.
                             * @member {number} tag
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @instance
                             */
                            Target.prototype.tag = 0;
    
                            /**
                             * Target confidence.
                             * @member {number} confidence
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @instance
                             */
                            Target.prototype.confidence = 0;
    
                            /**
                             * Target isStatic.
                             * @member {number} isStatic
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @instance
                             */
                            Target.prototype.isStatic = 0;
    
                            /**
                             * Creates a new Target instance using the specified properties.
                             * @function create
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.ITarget=} [properties] Properties to set
                             * @returns {density.protocol.openarea.v1.Frame.Target} Target instance
                             */
                            Target.create = function create(properties) {
                                return new Target(properties);
                            };
    
                            /**
                             * Encodes the specified Target message. Does not implicitly {@link density.protocol.openarea.v1.Frame.Target.verify|verify} messages.
                             * @function encode
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.ITarget} message Target message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            Target.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                                    writer.uint32(/* id 1, wireType 5 =*/13).float(message.x);
                                if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                                    writer.uint32(/* id 2, wireType 5 =*/21).float(message.y);
                                if (message.velX != null && Object.hasOwnProperty.call(message, "velX"))
                                    writer.uint32(/* id 4, wireType 5 =*/37).float(message.velX);
                                if (message.velY != null && Object.hasOwnProperty.call(message, "velY"))
                                    writer.uint32(/* id 5, wireType 5 =*/45).float(message.velY);
                                if (message.accX != null && Object.hasOwnProperty.call(message, "accX"))
                                    writer.uint32(/* id 7, wireType 5 =*/61).float(message.accX);
                                if (message.accY != null && Object.hasOwnProperty.call(message, "accY"))
                                    writer.uint32(/* id 8, wireType 5 =*/69).float(message.accY);
                                if (message.tag != null && Object.hasOwnProperty.call(message, "tag"))
                                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.tag);
                                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                    writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.id);
                                if (message.confidence != null && Object.hasOwnProperty.call(message, "confidence"))
                                    writer.uint32(/* id 11, wireType 5 =*/93).float(message.confidence);
                                if (message.isStatic != null && Object.hasOwnProperty.call(message, "isStatic"))
                                    writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.isStatic);
                                return writer;
                            };
    
                            /**
                             * Encodes the specified Target message, length delimited. Does not implicitly {@link density.protocol.openarea.v1.Frame.Target.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.ITarget} message Target message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            Target.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a Target message from the specified reader or buffer.
                             * @function decode
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {density.protocol.openarea.v1.Frame.Target} Target
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            Target.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.protocol.openarea.v1.Frame.Target();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 10:
                                        message.id = reader.uint32();
                                        break;
                                    case 1:
                                        message.x = reader.float();
                                        break;
                                    case 2:
                                        message.y = reader.float();
                                        break;
                                    case 4:
                                        message.velX = reader.float();
                                        break;
                                    case 5:
                                        message.velY = reader.float();
                                        break;
                                    case 7:
                                        message.accX = reader.float();
                                        break;
                                    case 8:
                                        message.accY = reader.float();
                                        break;
                                    case 9:
                                        message.tag = reader.int32();
                                        break;
                                    case 11:
                                        message.confidence = reader.float();
                                        break;
                                    case 12:
                                        message.isStatic = reader.uint32();
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a Target message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {density.protocol.openarea.v1.Frame.Target} Target
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            Target.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a Target message.
                             * @function verify
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            Target.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.id != null && message.hasOwnProperty("id"))
                                    if (!$util.isInteger(message.id))
                                        return "id: integer expected";
                                if (message.x != null && message.hasOwnProperty("x"))
                                    if (typeof message.x !== "number")
                                        return "x: number expected";
                                if (message.y != null && message.hasOwnProperty("y"))
                                    if (typeof message.y !== "number")
                                        return "y: number expected";
                                if (message.velX != null && message.hasOwnProperty("velX"))
                                    if (typeof message.velX !== "number")
                                        return "velX: number expected";
                                if (message.velY != null && message.hasOwnProperty("velY"))
                                    if (typeof message.velY !== "number")
                                        return "velY: number expected";
                                if (message.accX != null && message.hasOwnProperty("accX"))
                                    if (typeof message.accX !== "number")
                                        return "accX: number expected";
                                if (message.accY != null && message.hasOwnProperty("accY"))
                                    if (typeof message.accY !== "number")
                                        return "accY: number expected";
                                if (message.tag != null && message.hasOwnProperty("tag"))
                                    if (!$util.isInteger(message.tag))
                                        return "tag: integer expected";
                                if (message.confidence != null && message.hasOwnProperty("confidence"))
                                    if (typeof message.confidence !== "number")
                                        return "confidence: number expected";
                                if (message.isStatic != null && message.hasOwnProperty("isStatic"))
                                    if (!$util.isInteger(message.isStatic))
                                        return "isStatic: integer expected";
                                return null;
                            };
    
                            /**
                             * Creates a Target message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {density.protocol.openarea.v1.Frame.Target} Target
                             */
                            Target.fromObject = function fromObject(object) {
                                if (object instanceof $root.density.protocol.openarea.v1.Frame.Target)
                                    return object;
                                var message = new $root.density.protocol.openarea.v1.Frame.Target();
                                if (object.id != null)
                                    message.id = object.id >>> 0;
                                if (object.x != null)
                                    message.x = Number(object.x);
                                if (object.y != null)
                                    message.y = Number(object.y);
                                if (object.velX != null)
                                    message.velX = Number(object.velX);
                                if (object.velY != null)
                                    message.velY = Number(object.velY);
                                if (object.accX != null)
                                    message.accX = Number(object.accX);
                                if (object.accY != null)
                                    message.accY = Number(object.accY);
                                if (object.tag != null)
                                    message.tag = object.tag | 0;
                                if (object.confidence != null)
                                    message.confidence = Number(object.confidence);
                                if (object.isStatic != null)
                                    message.isStatic = object.isStatic >>> 0;
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a Target message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.Target} message Target
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            Target.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.defaults) {
                                    object.x = 0;
                                    object.y = 0;
                                    object.velX = 0;
                                    object.velY = 0;
                                    object.accX = 0;
                                    object.accY = 0;
                                    object.tag = 0;
                                    object.id = 0;
                                    object.confidence = 0;
                                    object.isStatic = 0;
                                }
                                if (message.x != null && message.hasOwnProperty("x"))
                                    object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
                                if (message.y != null && message.hasOwnProperty("y"))
                                    object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
                                if (message.velX != null && message.hasOwnProperty("velX"))
                                    object.velX = options.json && !isFinite(message.velX) ? String(message.velX) : message.velX;
                                if (message.velY != null && message.hasOwnProperty("velY"))
                                    object.velY = options.json && !isFinite(message.velY) ? String(message.velY) : message.velY;
                                if (message.accX != null && message.hasOwnProperty("accX"))
                                    object.accX = options.json && !isFinite(message.accX) ? String(message.accX) : message.accX;
                                if (message.accY != null && message.hasOwnProperty("accY"))
                                    object.accY = options.json && !isFinite(message.accY) ? String(message.accY) : message.accY;
                                if (message.tag != null && message.hasOwnProperty("tag"))
                                    object.tag = message.tag;
                                if (message.id != null && message.hasOwnProperty("id"))
                                    object.id = message.id;
                                if (message.confidence != null && message.hasOwnProperty("confidence"))
                                    object.confidence = options.json && !isFinite(message.confidence) ? String(message.confidence) : message.confidence;
                                if (message.isStatic != null && message.hasOwnProperty("isStatic"))
                                    object.isStatic = message.isStatic;
                                return object;
                            };
    
                            /**
                             * Converts this Target to JSON.
                             * @function toJSON
                             * @memberof density.protocol.openarea.v1.Frame.Target
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            Target.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return Target;
                        })();
    
                        Frame.ChamberData = (function() {
    
                            /**
                             * Properties of a ChamberData.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @interface IChamberData
                             * @property {number|null} [gimbal_position_angle_horizontal] ChamberData gimbal_position_angle_horizontal
                             * @property {number|null} [gimbal_position_angle_vertical] ChamberData gimbal_position_angle_vertical
                             */
    
                            /**
                             * Constructs a new ChamberData.
                             * @memberof density.protocol.openarea.v1.Frame
                             * @classdesc Represents a ChamberData.
                             * @implements IChamberData
                             * @constructor
                             * @param {density.protocol.openarea.v1.Frame.IChamberData=} [properties] Properties to set
                             */
                            function ChamberData(properties) {
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * ChamberData gimbal_position_angle_horizontal.
                             * @member {number} gimbal_position_angle_horizontal
                             * @memberof density.protocol.openarea.v1.Frame.ChamberData
                             * @instance
                             */
                            ChamberData.prototype.gimbal_position_angle_horizontal = 0;
    
                            /**
                             * ChamberData gimbal_position_angle_vertical.
                             * @member {number} gimbal_position_angle_vertical
                             * @memberof density.protocol.openarea.v1.Frame.ChamberData
                             * @instance
                             */
                            ChamberData.prototype.gimbal_position_angle_vertical = 0;
    
                            /**
                             * Creates a new ChamberData instance using the specified properties.
                             * @function create
                             * @memberof density.protocol.openarea.v1.Frame.ChamberData
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.IChamberData=} [properties] Properties to set
                             * @returns {density.protocol.openarea.v1.Frame.ChamberData} ChamberData instance
                             */
                            ChamberData.create = function create(properties) {
                                return new ChamberData(properties);
                            };
    
                            /**
                             * Encodes the specified ChamberData message. Does not implicitly {@link density.protocol.openarea.v1.Frame.ChamberData.verify|verify} messages.
                             * @function encode
                             * @memberof density.protocol.openarea.v1.Frame.ChamberData
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.IChamberData} message ChamberData message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            ChamberData.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.gimbal_position_angle_horizontal != null && Object.hasOwnProperty.call(message, "gimbal_position_angle_horizontal"))
                                    writer.uint32(/* id 1, wireType 5 =*/13).float(message.gimbal_position_angle_horizontal);
                                if (message.gimbal_position_angle_vertical != null && Object.hasOwnProperty.call(message, "gimbal_position_angle_vertical"))
                                    writer.uint32(/* id 2, wireType 5 =*/21).float(message.gimbal_position_angle_vertical);
                                return writer;
                            };
    
                            /**
                             * Encodes the specified ChamberData message, length delimited. Does not implicitly {@link density.protocol.openarea.v1.Frame.ChamberData.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.ChamberData
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.IChamberData} message ChamberData message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            ChamberData.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a ChamberData message from the specified reader or buffer.
                             * @function decode
                             * @memberof density.protocol.openarea.v1.Frame.ChamberData
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {density.protocol.openarea.v1.Frame.ChamberData} ChamberData
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            ChamberData.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.protocol.openarea.v1.Frame.ChamberData();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1:
                                        message.gimbal_position_angle_horizontal = reader.float();
                                        break;
                                    case 2:
                                        message.gimbal_position_angle_vertical = reader.float();
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a ChamberData message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof density.protocol.openarea.v1.Frame.ChamberData
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {density.protocol.openarea.v1.Frame.ChamberData} ChamberData
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            ChamberData.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a ChamberData message.
                             * @function verify
                             * @memberof density.protocol.openarea.v1.Frame.ChamberData
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            ChamberData.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.gimbal_position_angle_horizontal != null && message.hasOwnProperty("gimbal_position_angle_horizontal"))
                                    if (typeof message.gimbal_position_angle_horizontal !== "number")
                                        return "gimbal_position_angle_horizontal: number expected";
                                if (message.gimbal_position_angle_vertical != null && message.hasOwnProperty("gimbal_position_angle_vertical"))
                                    if (typeof message.gimbal_position_angle_vertical !== "number")
                                        return "gimbal_position_angle_vertical: number expected";
                                return null;
                            };
    
                            /**
                             * Creates a ChamberData message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof density.protocol.openarea.v1.Frame.ChamberData
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {density.protocol.openarea.v1.Frame.ChamberData} ChamberData
                             */
                            ChamberData.fromObject = function fromObject(object) {
                                if (object instanceof $root.density.protocol.openarea.v1.Frame.ChamberData)
                                    return object;
                                var message = new $root.density.protocol.openarea.v1.Frame.ChamberData();
                                if (object.gimbal_position_angle_horizontal != null)
                                    message.gimbal_position_angle_horizontal = Number(object.gimbal_position_angle_horizontal);
                                if (object.gimbal_position_angle_vertical != null)
                                    message.gimbal_position_angle_vertical = Number(object.gimbal_position_angle_vertical);
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a ChamberData message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof density.protocol.openarea.v1.Frame.ChamberData
                             * @static
                             * @param {density.protocol.openarea.v1.Frame.ChamberData} message ChamberData
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            ChamberData.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.defaults) {
                                    object.gimbal_position_angle_horizontal = 0;
                                    object.gimbal_position_angle_vertical = 0;
                                }
                                if (message.gimbal_position_angle_horizontal != null && message.hasOwnProperty("gimbal_position_angle_horizontal"))
                                    object.gimbal_position_angle_horizontal = options.json && !isFinite(message.gimbal_position_angle_horizontal) ? String(message.gimbal_position_angle_horizontal) : message.gimbal_position_angle_horizontal;
                                if (message.gimbal_position_angle_vertical != null && message.hasOwnProperty("gimbal_position_angle_vertical"))
                                    object.gimbal_position_angle_vertical = options.json && !isFinite(message.gimbal_position_angle_vertical) ? String(message.gimbal_position_angle_vertical) : message.gimbal_position_angle_vertical;
                                return object;
                            };
    
                            /**
                             * Converts this ChamberData to JSON.
                             * @function toJSON
                             * @memberof density.protocol.openarea.v1.Frame.ChamberData
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            ChamberData.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return ChamberData;
                        })();
    
                        return Frame;
                    })();
    
                    v1.Scene = (function() {
    
                        /**
                         * Properties of a Scene.
                         * @memberof density.protocol.openarea.v1
                         * @interface IScene
                         * @property {boolean|null} [flashed] Scene flashed
                         * @property {density.protocol.openarea.v1.Scene.IChirpDescriptor|null} [chirp] Scene chirp
                         * @property {number|null} [range] Scene range
                         * @property {Array.<density.protocol.openarea.v1.Scene.IROI>|null} [subspaces] Scene subspaces
                         * @property {number|null} [ifRangeBinMin] Scene ifRangeBinMin
                         * @property {number|null} [ifRangeBinMax] Scene ifRangeBinMax
                         */
    
                        /**
                         * Constructs a new Scene.
                         * @memberof density.protocol.openarea.v1
                         * @classdesc Represents a Scene.
                         * @implements IScene
                         * @constructor
                         * @param {density.protocol.openarea.v1.IScene=} [properties] Properties to set
                         */
                        function Scene(properties) {
                            this.subspaces = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Scene flashed.
                         * @member {boolean} flashed
                         * @memberof density.protocol.openarea.v1.Scene
                         * @instance
                         */
                        Scene.prototype.flashed = false;
    
                        /**
                         * Scene chirp.
                         * @member {density.protocol.openarea.v1.Scene.IChirpDescriptor|null|undefined} chirp
                         * @memberof density.protocol.openarea.v1.Scene
                         * @instance
                         */
                        Scene.prototype.chirp = null;
    
                        /**
                         * Scene range.
                         * @member {number} range
                         * @memberof density.protocol.openarea.v1.Scene
                         * @instance
                         */
                        Scene.prototype.range = 0;
    
                        /**
                         * Scene subspaces.
                         * @member {Array.<density.protocol.openarea.v1.Scene.IROI>} subspaces
                         * @memberof density.protocol.openarea.v1.Scene
                         * @instance
                         */
                        Scene.prototype.subspaces = $util.emptyArray;
    
                        /**
                         * Scene ifRangeBinMin.
                         * @member {number} ifRangeBinMin
                         * @memberof density.protocol.openarea.v1.Scene
                         * @instance
                         */
                        Scene.prototype.ifRangeBinMin = 0;
    
                        /**
                         * Scene ifRangeBinMax.
                         * @member {number} ifRangeBinMax
                         * @memberof density.protocol.openarea.v1.Scene
                         * @instance
                         */
                        Scene.prototype.ifRangeBinMax = 0;
    
                        /**
                         * Creates a new Scene instance using the specified properties.
                         * @function create
                         * @memberof density.protocol.openarea.v1.Scene
                         * @static
                         * @param {density.protocol.openarea.v1.IScene=} [properties] Properties to set
                         * @returns {density.protocol.openarea.v1.Scene} Scene instance
                         */
                        Scene.create = function create(properties) {
                            return new Scene(properties);
                        };
    
                        /**
                         * Encodes the specified Scene message. Does not implicitly {@link density.protocol.openarea.v1.Scene.verify|verify} messages.
                         * @function encode
                         * @memberof density.protocol.openarea.v1.Scene
                         * @static
                         * @param {density.protocol.openarea.v1.IScene} message Scene message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Scene.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.flashed != null && Object.hasOwnProperty.call(message, "flashed"))
                                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.flashed);
                            if (message.chirp != null && Object.hasOwnProperty.call(message, "chirp"))
                                $root.density.protocol.openarea.v1.Scene.ChirpDescriptor.encode(message.chirp, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            if (message.range != null && Object.hasOwnProperty.call(message, "range"))
                                writer.uint32(/* id 4, wireType 5 =*/37).float(message.range);
                            if (message.subspaces != null && message.subspaces.length)
                                for (var i = 0; i < message.subspaces.length; ++i)
                                    $root.density.protocol.openarea.v1.Scene.ROI.encode(message.subspaces[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            if (message.ifRangeBinMin != null && Object.hasOwnProperty.call(message, "ifRangeBinMin"))
                                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.ifRangeBinMin);
                            if (message.ifRangeBinMax != null && Object.hasOwnProperty.call(message, "ifRangeBinMax"))
                                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.ifRangeBinMax);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Scene message, length delimited. Does not implicitly {@link density.protocol.openarea.v1.Scene.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof density.protocol.openarea.v1.Scene
                         * @static
                         * @param {density.protocol.openarea.v1.IScene} message Scene message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Scene.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Scene message from the specified reader or buffer.
                         * @function decode
                         * @memberof density.protocol.openarea.v1.Scene
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {density.protocol.openarea.v1.Scene} Scene
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Scene.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.protocol.openarea.v1.Scene();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.flashed = reader.bool();
                                    break;
                                case 2:
                                    message.chirp = $root.density.protocol.openarea.v1.Scene.ChirpDescriptor.decode(reader, reader.uint32());
                                    break;
                                case 4:
                                    message.range = reader.float();
                                    break;
                                case 5:
                                    if (!(message.subspaces && message.subspaces.length))
                                        message.subspaces = [];
                                    message.subspaces.push($root.density.protocol.openarea.v1.Scene.ROI.decode(reader, reader.uint32()));
                                    break;
                                case 6:
                                    message.ifRangeBinMin = reader.uint32();
                                    break;
                                case 7:
                                    message.ifRangeBinMax = reader.uint32();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Scene message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof density.protocol.openarea.v1.Scene
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {density.protocol.openarea.v1.Scene} Scene
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Scene.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Scene message.
                         * @function verify
                         * @memberof density.protocol.openarea.v1.Scene
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Scene.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.flashed != null && message.hasOwnProperty("flashed"))
                                if (typeof message.flashed !== "boolean")
                                    return "flashed: boolean expected";
                            if (message.chirp != null && message.hasOwnProperty("chirp")) {
                                var error = $root.density.protocol.openarea.v1.Scene.ChirpDescriptor.verify(message.chirp);
                                if (error)
                                    return "chirp." + error;
                            }
                            if (message.range != null && message.hasOwnProperty("range"))
                                if (typeof message.range !== "number")
                                    return "range: number expected";
                            if (message.subspaces != null && message.hasOwnProperty("subspaces")) {
                                if (!Array.isArray(message.subspaces))
                                    return "subspaces: array expected";
                                for (var i = 0; i < message.subspaces.length; ++i) {
                                    var error = $root.density.protocol.openarea.v1.Scene.ROI.verify(message.subspaces[i]);
                                    if (error)
                                        return "subspaces." + error;
                                }
                            }
                            if (message.ifRangeBinMin != null && message.hasOwnProperty("ifRangeBinMin"))
                                if (!$util.isInteger(message.ifRangeBinMin))
                                    return "ifRangeBinMin: integer expected";
                            if (message.ifRangeBinMax != null && message.hasOwnProperty("ifRangeBinMax"))
                                if (!$util.isInteger(message.ifRangeBinMax))
                                    return "ifRangeBinMax: integer expected";
                            return null;
                        };
    
                        /**
                         * Creates a Scene message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof density.protocol.openarea.v1.Scene
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {density.protocol.openarea.v1.Scene} Scene
                         */
                        Scene.fromObject = function fromObject(object) {
                            if (object instanceof $root.density.protocol.openarea.v1.Scene)
                                return object;
                            var message = new $root.density.protocol.openarea.v1.Scene();
                            if (object.flashed != null)
                                message.flashed = Boolean(object.flashed);
                            if (object.chirp != null) {
                                if (typeof object.chirp !== "object")
                                    throw TypeError(".density.protocol.openarea.v1.Scene.chirp: object expected");
                                message.chirp = $root.density.protocol.openarea.v1.Scene.ChirpDescriptor.fromObject(object.chirp);
                            }
                            if (object.range != null)
                                message.range = Number(object.range);
                            if (object.subspaces) {
                                if (!Array.isArray(object.subspaces))
                                    throw TypeError(".density.protocol.openarea.v1.Scene.subspaces: array expected");
                                message.subspaces = [];
                                for (var i = 0; i < object.subspaces.length; ++i) {
                                    if (typeof object.subspaces[i] !== "object")
                                        throw TypeError(".density.protocol.openarea.v1.Scene.subspaces: object expected");
                                    message.subspaces[i] = $root.density.protocol.openarea.v1.Scene.ROI.fromObject(object.subspaces[i]);
                                }
                            }
                            if (object.ifRangeBinMin != null)
                                message.ifRangeBinMin = object.ifRangeBinMin >>> 0;
                            if (object.ifRangeBinMax != null)
                                message.ifRangeBinMax = object.ifRangeBinMax >>> 0;
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Scene message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof density.protocol.openarea.v1.Scene
                         * @static
                         * @param {density.protocol.openarea.v1.Scene} message Scene
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Scene.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.subspaces = [];
                            if (options.defaults) {
                                object.flashed = false;
                                object.chirp = null;
                                object.range = 0;
                                object.ifRangeBinMin = 0;
                                object.ifRangeBinMax = 0;
                            }
                            if (message.flashed != null && message.hasOwnProperty("flashed"))
                                object.flashed = message.flashed;
                            if (message.chirp != null && message.hasOwnProperty("chirp"))
                                object.chirp = $root.density.protocol.openarea.v1.Scene.ChirpDescriptor.toObject(message.chirp, options);
                            if (message.range != null && message.hasOwnProperty("range"))
                                object.range = options.json && !isFinite(message.range) ? String(message.range) : message.range;
                            if (message.subspaces && message.subspaces.length) {
                                object.subspaces = [];
                                for (var j = 0; j < message.subspaces.length; ++j)
                                    object.subspaces[j] = $root.density.protocol.openarea.v1.Scene.ROI.toObject(message.subspaces[j], options);
                            }
                            if (message.ifRangeBinMin != null && message.hasOwnProperty("ifRangeBinMin"))
                                object.ifRangeBinMin = message.ifRangeBinMin;
                            if (message.ifRangeBinMax != null && message.hasOwnProperty("ifRangeBinMax"))
                                object.ifRangeBinMax = message.ifRangeBinMax;
                            return object;
                        };
    
                        /**
                         * Converts this Scene to JSON.
                         * @function toJSON
                         * @memberof density.protocol.openarea.v1.Scene
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Scene.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        Scene.ROI = (function() {
    
                            /**
                             * Properties of a ROI.
                             * @memberof density.protocol.openarea.v1.Scene
                             * @interface IROI
                             * @property {number|null} [px] ROI px
                             * @property {number|null} [py] ROI py
                             * @property {number|null} [rx] ROI rx
                             * @property {number|null} [ry] ROI ry
                             * @property {number|null} [phi] ROI phi
                             */
    
                            /**
                             * Constructs a new ROI.
                             * @memberof density.protocol.openarea.v1.Scene
                             * @classdesc Represents a ROI.
                             * @implements IROI
                             * @constructor
                             * @param {density.protocol.openarea.v1.Scene.IROI=} [properties] Properties to set
                             */
                            function ROI(properties) {
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * ROI px.
                             * @member {number} px
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @instance
                             */
                            ROI.prototype.px = 0;
    
                            /**
                             * ROI py.
                             * @member {number} py
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @instance
                             */
                            ROI.prototype.py = 0;
    
                            /**
                             * ROI rx.
                             * @member {number} rx
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @instance
                             */
                            ROI.prototype.rx = 0;
    
                            /**
                             * ROI ry.
                             * @member {number} ry
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @instance
                             */
                            ROI.prototype.ry = 0;
    
                            /**
                             * ROI phi.
                             * @member {number} phi
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @instance
                             */
                            ROI.prototype.phi = 0;
    
                            /**
                             * Creates a new ROI instance using the specified properties.
                             * @function create
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @static
                             * @param {density.protocol.openarea.v1.Scene.IROI=} [properties] Properties to set
                             * @returns {density.protocol.openarea.v1.Scene.ROI} ROI instance
                             */
                            ROI.create = function create(properties) {
                                return new ROI(properties);
                            };
    
                            /**
                             * Encodes the specified ROI message. Does not implicitly {@link density.protocol.openarea.v1.Scene.ROI.verify|verify} messages.
                             * @function encode
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @static
                             * @param {density.protocol.openarea.v1.Scene.IROI} message ROI message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            ROI.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.px != null && Object.hasOwnProperty.call(message, "px"))
                                    writer.uint32(/* id 1, wireType 5 =*/13).float(message.px);
                                if (message.py != null && Object.hasOwnProperty.call(message, "py"))
                                    writer.uint32(/* id 2, wireType 5 =*/21).float(message.py);
                                if (message.rx != null && Object.hasOwnProperty.call(message, "rx"))
                                    writer.uint32(/* id 3, wireType 5 =*/29).float(message.rx);
                                if (message.ry != null && Object.hasOwnProperty.call(message, "ry"))
                                    writer.uint32(/* id 4, wireType 5 =*/37).float(message.ry);
                                if (message.phi != null && Object.hasOwnProperty.call(message, "phi"))
                                    writer.uint32(/* id 5, wireType 5 =*/45).float(message.phi);
                                return writer;
                            };
    
                            /**
                             * Encodes the specified ROI message, length delimited. Does not implicitly {@link density.protocol.openarea.v1.Scene.ROI.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @static
                             * @param {density.protocol.openarea.v1.Scene.IROI} message ROI message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            ROI.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a ROI message from the specified reader or buffer.
                             * @function decode
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {density.protocol.openarea.v1.Scene.ROI} ROI
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            ROI.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.protocol.openarea.v1.Scene.ROI();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1:
                                        message.px = reader.float();
                                        break;
                                    case 2:
                                        message.py = reader.float();
                                        break;
                                    case 3:
                                        message.rx = reader.float();
                                        break;
                                    case 4:
                                        message.ry = reader.float();
                                        break;
                                    case 5:
                                        message.phi = reader.float();
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a ROI message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {density.protocol.openarea.v1.Scene.ROI} ROI
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            ROI.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a ROI message.
                             * @function verify
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            ROI.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.px != null && message.hasOwnProperty("px"))
                                    if (typeof message.px !== "number")
                                        return "px: number expected";
                                if (message.py != null && message.hasOwnProperty("py"))
                                    if (typeof message.py !== "number")
                                        return "py: number expected";
                                if (message.rx != null && message.hasOwnProperty("rx"))
                                    if (typeof message.rx !== "number")
                                        return "rx: number expected";
                                if (message.ry != null && message.hasOwnProperty("ry"))
                                    if (typeof message.ry !== "number")
                                        return "ry: number expected";
                                if (message.phi != null && message.hasOwnProperty("phi"))
                                    if (typeof message.phi !== "number")
                                        return "phi: number expected";
                                return null;
                            };
    
                            /**
                             * Creates a ROI message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {density.protocol.openarea.v1.Scene.ROI} ROI
                             */
                            ROI.fromObject = function fromObject(object) {
                                if (object instanceof $root.density.protocol.openarea.v1.Scene.ROI)
                                    return object;
                                var message = new $root.density.protocol.openarea.v1.Scene.ROI();
                                if (object.px != null)
                                    message.px = Number(object.px);
                                if (object.py != null)
                                    message.py = Number(object.py);
                                if (object.rx != null)
                                    message.rx = Number(object.rx);
                                if (object.ry != null)
                                    message.ry = Number(object.ry);
                                if (object.phi != null)
                                    message.phi = Number(object.phi);
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a ROI message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @static
                             * @param {density.protocol.openarea.v1.Scene.ROI} message ROI
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            ROI.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.defaults) {
                                    object.px = 0;
                                    object.py = 0;
                                    object.rx = 0;
                                    object.ry = 0;
                                    object.phi = 0;
                                }
                                if (message.px != null && message.hasOwnProperty("px"))
                                    object.px = options.json && !isFinite(message.px) ? String(message.px) : message.px;
                                if (message.py != null && message.hasOwnProperty("py"))
                                    object.py = options.json && !isFinite(message.py) ? String(message.py) : message.py;
                                if (message.rx != null && message.hasOwnProperty("rx"))
                                    object.rx = options.json && !isFinite(message.rx) ? String(message.rx) : message.rx;
                                if (message.ry != null && message.hasOwnProperty("ry"))
                                    object.ry = options.json && !isFinite(message.ry) ? String(message.ry) : message.ry;
                                if (message.phi != null && message.hasOwnProperty("phi"))
                                    object.phi = options.json && !isFinite(message.phi) ? String(message.phi) : message.phi;
                                return object;
                            };
    
                            /**
                             * Converts this ROI to JSON.
                             * @function toJSON
                             * @memberof density.protocol.openarea.v1.Scene.ROI
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            ROI.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return ROI;
                        })();
    
                        /**
                         * FirmwareType enum.
                         * @name density.protocol.openarea.v1.Scene.FirmwareType
                         * @enum {number}
                         * @property {number} UNKNOWN=0 UNKNOWN value
                         * @property {number} TI_3D_FFT=1 TI_3D_FFT value
                         * @property {number} TI_3D_CAPON=2 TI_3D_CAPON value
                         * @property {number} TI_CALIBRATION=3 TI_CALIBRATION value
                         * @property {number} TI_2D_CAPON=4 TI_2D_CAPON value
                         */
                        Scene.FirmwareType = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "UNKNOWN"] = 0;
                            values[valuesById[1] = "TI_3D_FFT"] = 1;
                            values[valuesById[2] = "TI_3D_CAPON"] = 2;
                            values[valuesById[3] = "TI_CALIBRATION"] = 3;
                            values[valuesById[4] = "TI_2D_CAPON"] = 4;
                            return values;
                        })();
    
                        Scene.ChirpDescriptor = (function() {
    
                            /**
                             * Properties of a ChirpDescriptor.
                             * @memberof density.protocol.openarea.v1.Scene
                             * @interface IChirpDescriptor
                             * @property {number|null} [numRangeBins] ChirpDescriptor numRangeBins
                             * @property {number|null} [numDopplerBins] ChirpDescriptor numDopplerBins
                             * @property {number|null} [rangeResolution] ChirpDescriptor rangeResolution
                             * @property {number|null} [dopplerResolution] ChirpDescriptor dopplerResolution
                             * @property {number|null} [numTx] ChirpDescriptor numTx
                             * @property {number|null} [numRx] ChirpDescriptor numRx
                             * @property {number|null} [FPS] ChirpDescriptor FPS
                             * @property {string|null} [name] ChirpDescriptor name
                             * @property {density.protocol.openarea.v1.Scene.FirmwareType|null} [firmware] ChirpDescriptor firmware
                             * @property {number|null} [txBackOff_dB] ChirpDescriptor txBackOff_dB
                             * @property {number|null} [rangeStep] ChirpDescriptor rangeStep
                             * @property {number|null} [dopplerStep] ChirpDescriptor dopplerStep
                             * @property {number|null} [intraframeOn] ChirpDescriptor intraframeOn
                             * @property {number|null} [carrierFreq] ChirpDescriptor carrierFreq
                             */
    
                            /**
                             * Constructs a new ChirpDescriptor.
                             * @memberof density.protocol.openarea.v1.Scene
                             * @classdesc Represents a ChirpDescriptor.
                             * @implements IChirpDescriptor
                             * @constructor
                             * @param {density.protocol.openarea.v1.Scene.IChirpDescriptor=} [properties] Properties to set
                             */
                            function ChirpDescriptor(properties) {
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * ChirpDescriptor numRangeBins.
                             * @member {number} numRangeBins
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.numRangeBins = 0;
    
                            /**
                             * ChirpDescriptor numDopplerBins.
                             * @member {number} numDopplerBins
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.numDopplerBins = 0;
    
                            /**
                             * ChirpDescriptor rangeResolution.
                             * @member {number} rangeResolution
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.rangeResolution = 0;
    
                            /**
                             * ChirpDescriptor dopplerResolution.
                             * @member {number} dopplerResolution
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.dopplerResolution = 0;
    
                            /**
                             * ChirpDescriptor numTx.
                             * @member {number} numTx
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.numTx = 0;
    
                            /**
                             * ChirpDescriptor numRx.
                             * @member {number} numRx
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.numRx = 0;
    
                            /**
                             * ChirpDescriptor FPS.
                             * @member {number} FPS
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.FPS = 0;
    
                            /**
                             * ChirpDescriptor name.
                             * @member {string} name
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.name = "";
    
                            /**
                             * ChirpDescriptor firmware.
                             * @member {density.protocol.openarea.v1.Scene.FirmwareType} firmware
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.firmware = 0;
    
                            /**
                             * ChirpDescriptor txBackOff_dB.
                             * @member {number} txBackOff_dB
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.txBackOff_dB = 0;
    
                            /**
                             * ChirpDescriptor rangeStep.
                             * @member {number} rangeStep
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.rangeStep = 0;
    
                            /**
                             * ChirpDescriptor dopplerStep.
                             * @member {number} dopplerStep
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.dopplerStep = 0;
    
                            /**
                             * ChirpDescriptor intraframeOn.
                             * @member {number} intraframeOn
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.intraframeOn = 0;
    
                            /**
                             * ChirpDescriptor carrierFreq.
                             * @member {number} carrierFreq
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             */
                            ChirpDescriptor.prototype.carrierFreq = 0;
    
                            /**
                             * Creates a new ChirpDescriptor instance using the specified properties.
                             * @function create
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @static
                             * @param {density.protocol.openarea.v1.Scene.IChirpDescriptor=} [properties] Properties to set
                             * @returns {density.protocol.openarea.v1.Scene.ChirpDescriptor} ChirpDescriptor instance
                             */
                            ChirpDescriptor.create = function create(properties) {
                                return new ChirpDescriptor(properties);
                            };
    
                            /**
                             * Encodes the specified ChirpDescriptor message. Does not implicitly {@link density.protocol.openarea.v1.Scene.ChirpDescriptor.verify|verify} messages.
                             * @function encode
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @static
                             * @param {density.protocol.openarea.v1.Scene.IChirpDescriptor} message ChirpDescriptor message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            ChirpDescriptor.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.numRangeBins != null && Object.hasOwnProperty.call(message, "numRangeBins"))
                                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.numRangeBins);
                                if (message.numDopplerBins != null && Object.hasOwnProperty.call(message, "numDopplerBins"))
                                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.numDopplerBins);
                                if (message.rangeResolution != null && Object.hasOwnProperty.call(message, "rangeResolution"))
                                    writer.uint32(/* id 3, wireType 5 =*/29).float(message.rangeResolution);
                                if (message.dopplerResolution != null && Object.hasOwnProperty.call(message, "dopplerResolution"))
                                    writer.uint32(/* id 4, wireType 5 =*/37).float(message.dopplerResolution);
                                if (message.numTx != null && Object.hasOwnProperty.call(message, "numTx"))
                                    writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.numTx);
                                if (message.numRx != null && Object.hasOwnProperty.call(message, "numRx"))
                                    writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.numRx);
                                if (message.FPS != null && Object.hasOwnProperty.call(message, "FPS"))
                                    writer.uint32(/* id 7, wireType 5 =*/61).float(message.FPS);
                                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.name);
                                if (message.firmware != null && Object.hasOwnProperty.call(message, "firmware"))
                                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.firmware);
                                if (message.txBackOff_dB != null && Object.hasOwnProperty.call(message, "txBackOff_dB"))
                                    writer.uint32(/* id 10, wireType 0 =*/80).int32(message.txBackOff_dB);
                                if (message.rangeStep != null && Object.hasOwnProperty.call(message, "rangeStep"))
                                    writer.uint32(/* id 11, wireType 5 =*/93).float(message.rangeStep);
                                if (message.dopplerStep != null && Object.hasOwnProperty.call(message, "dopplerStep"))
                                    writer.uint32(/* id 12, wireType 5 =*/101).float(message.dopplerStep);
                                if (message.intraframeOn != null && Object.hasOwnProperty.call(message, "intraframeOn"))
                                    writer.uint32(/* id 13, wireType 0 =*/104).int32(message.intraframeOn);
                                if (message.carrierFreq != null && Object.hasOwnProperty.call(message, "carrierFreq"))
                                    writer.uint32(/* id 14, wireType 5 =*/117).float(message.carrierFreq);
                                return writer;
                            };
    
                            /**
                             * Encodes the specified ChirpDescriptor message, length delimited. Does not implicitly {@link density.protocol.openarea.v1.Scene.ChirpDescriptor.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @static
                             * @param {density.protocol.openarea.v1.Scene.IChirpDescriptor} message ChirpDescriptor message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            ChirpDescriptor.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a ChirpDescriptor message from the specified reader or buffer.
                             * @function decode
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {density.protocol.openarea.v1.Scene.ChirpDescriptor} ChirpDescriptor
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            ChirpDescriptor.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.protocol.openarea.v1.Scene.ChirpDescriptor();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1:
                                        message.numRangeBins = reader.uint32();
                                        break;
                                    case 2:
                                        message.numDopplerBins = reader.uint32();
                                        break;
                                    case 3:
                                        message.rangeResolution = reader.float();
                                        break;
                                    case 4:
                                        message.dopplerResolution = reader.float();
                                        break;
                                    case 5:
                                        message.numTx = reader.uint32();
                                        break;
                                    case 6:
                                        message.numRx = reader.uint32();
                                        break;
                                    case 7:
                                        message.FPS = reader.float();
                                        break;
                                    case 8:
                                        message.name = reader.string();
                                        break;
                                    case 9:
                                        message.firmware = reader.int32();
                                        break;
                                    case 10:
                                        message.txBackOff_dB = reader.int32();
                                        break;
                                    case 11:
                                        message.rangeStep = reader.float();
                                        break;
                                    case 12:
                                        message.dopplerStep = reader.float();
                                        break;
                                    case 13:
                                        message.intraframeOn = reader.int32();
                                        break;
                                    case 14:
                                        message.carrierFreq = reader.float();
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a ChirpDescriptor message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {density.protocol.openarea.v1.Scene.ChirpDescriptor} ChirpDescriptor
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            ChirpDescriptor.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a ChirpDescriptor message.
                             * @function verify
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            ChirpDescriptor.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.numRangeBins != null && message.hasOwnProperty("numRangeBins"))
                                    if (!$util.isInteger(message.numRangeBins))
                                        return "numRangeBins: integer expected";
                                if (message.numDopplerBins != null && message.hasOwnProperty("numDopplerBins"))
                                    if (!$util.isInteger(message.numDopplerBins))
                                        return "numDopplerBins: integer expected";
                                if (message.rangeResolution != null && message.hasOwnProperty("rangeResolution"))
                                    if (typeof message.rangeResolution !== "number")
                                        return "rangeResolution: number expected";
                                if (message.dopplerResolution != null && message.hasOwnProperty("dopplerResolution"))
                                    if (typeof message.dopplerResolution !== "number")
                                        return "dopplerResolution: number expected";
                                if (message.numTx != null && message.hasOwnProperty("numTx"))
                                    if (!$util.isInteger(message.numTx))
                                        return "numTx: integer expected";
                                if (message.numRx != null && message.hasOwnProperty("numRx"))
                                    if (!$util.isInteger(message.numRx))
                                        return "numRx: integer expected";
                                if (message.FPS != null && message.hasOwnProperty("FPS"))
                                    if (typeof message.FPS !== "number")
                                        return "FPS: number expected";
                                if (message.name != null && message.hasOwnProperty("name"))
                                    if (!$util.isString(message.name))
                                        return "name: string expected";
                                if (message.firmware != null && message.hasOwnProperty("firmware"))
                                    switch (message.firmware) {
                                    default:
                                        return "firmware: enum value expected";
                                    case 0:
                                    case 1:
                                    case 2:
                                    case 3:
                                    case 4:
                                        break;
                                    }
                                if (message.txBackOff_dB != null && message.hasOwnProperty("txBackOff_dB"))
                                    if (!$util.isInteger(message.txBackOff_dB))
                                        return "txBackOff_dB: integer expected";
                                if (message.rangeStep != null && message.hasOwnProperty("rangeStep"))
                                    if (typeof message.rangeStep !== "number")
                                        return "rangeStep: number expected";
                                if (message.dopplerStep != null && message.hasOwnProperty("dopplerStep"))
                                    if (typeof message.dopplerStep !== "number")
                                        return "dopplerStep: number expected";
                                if (message.intraframeOn != null && message.hasOwnProperty("intraframeOn"))
                                    if (!$util.isInteger(message.intraframeOn))
                                        return "intraframeOn: integer expected";
                                if (message.carrierFreq != null && message.hasOwnProperty("carrierFreq"))
                                    if (typeof message.carrierFreq !== "number")
                                        return "carrierFreq: number expected";
                                return null;
                            };
    
                            /**
                             * Creates a ChirpDescriptor message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {density.protocol.openarea.v1.Scene.ChirpDescriptor} ChirpDescriptor
                             */
                            ChirpDescriptor.fromObject = function fromObject(object) {
                                if (object instanceof $root.density.protocol.openarea.v1.Scene.ChirpDescriptor)
                                    return object;
                                var message = new $root.density.protocol.openarea.v1.Scene.ChirpDescriptor();
                                if (object.numRangeBins != null)
                                    message.numRangeBins = object.numRangeBins >>> 0;
                                if (object.numDopplerBins != null)
                                    message.numDopplerBins = object.numDopplerBins >>> 0;
                                if (object.rangeResolution != null)
                                    message.rangeResolution = Number(object.rangeResolution);
                                if (object.dopplerResolution != null)
                                    message.dopplerResolution = Number(object.dopplerResolution);
                                if (object.numTx != null)
                                    message.numTx = object.numTx >>> 0;
                                if (object.numRx != null)
                                    message.numRx = object.numRx >>> 0;
                                if (object.FPS != null)
                                    message.FPS = Number(object.FPS);
                                if (object.name != null)
                                    message.name = String(object.name);
                                switch (object.firmware) {
                                case "UNKNOWN":
                                case 0:
                                    message.firmware = 0;
                                    break;
                                case "TI_3D_FFT":
                                case 1:
                                    message.firmware = 1;
                                    break;
                                case "TI_3D_CAPON":
                                case 2:
                                    message.firmware = 2;
                                    break;
                                case "TI_CALIBRATION":
                                case 3:
                                    message.firmware = 3;
                                    break;
                                case "TI_2D_CAPON":
                                case 4:
                                    message.firmware = 4;
                                    break;
                                }
                                if (object.txBackOff_dB != null)
                                    message.txBackOff_dB = object.txBackOff_dB | 0;
                                if (object.rangeStep != null)
                                    message.rangeStep = Number(object.rangeStep);
                                if (object.dopplerStep != null)
                                    message.dopplerStep = Number(object.dopplerStep);
                                if (object.intraframeOn != null)
                                    message.intraframeOn = object.intraframeOn | 0;
                                if (object.carrierFreq != null)
                                    message.carrierFreq = Number(object.carrierFreq);
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a ChirpDescriptor message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @static
                             * @param {density.protocol.openarea.v1.Scene.ChirpDescriptor} message ChirpDescriptor
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            ChirpDescriptor.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.defaults) {
                                    object.numRangeBins = 0;
                                    object.numDopplerBins = 0;
                                    object.rangeResolution = 0;
                                    object.dopplerResolution = 0;
                                    object.numTx = 0;
                                    object.numRx = 0;
                                    object.FPS = 0;
                                    object.name = "";
                                    object.firmware = options.enums === String ? "UNKNOWN" : 0;
                                    object.txBackOff_dB = 0;
                                    object.rangeStep = 0;
                                    object.dopplerStep = 0;
                                    object.intraframeOn = 0;
                                    object.carrierFreq = 0;
                                }
                                if (message.numRangeBins != null && message.hasOwnProperty("numRangeBins"))
                                    object.numRangeBins = message.numRangeBins;
                                if (message.numDopplerBins != null && message.hasOwnProperty("numDopplerBins"))
                                    object.numDopplerBins = message.numDopplerBins;
                                if (message.rangeResolution != null && message.hasOwnProperty("rangeResolution"))
                                    object.rangeResolution = options.json && !isFinite(message.rangeResolution) ? String(message.rangeResolution) : message.rangeResolution;
                                if (message.dopplerResolution != null && message.hasOwnProperty("dopplerResolution"))
                                    object.dopplerResolution = options.json && !isFinite(message.dopplerResolution) ? String(message.dopplerResolution) : message.dopplerResolution;
                                if (message.numTx != null && message.hasOwnProperty("numTx"))
                                    object.numTx = message.numTx;
                                if (message.numRx != null && message.hasOwnProperty("numRx"))
                                    object.numRx = message.numRx;
                                if (message.FPS != null && message.hasOwnProperty("FPS"))
                                    object.FPS = options.json && !isFinite(message.FPS) ? String(message.FPS) : message.FPS;
                                if (message.name != null && message.hasOwnProperty("name"))
                                    object.name = message.name;
                                if (message.firmware != null && message.hasOwnProperty("firmware"))
                                    object.firmware = options.enums === String ? $root.density.protocol.openarea.v1.Scene.FirmwareType[message.firmware] : message.firmware;
                                if (message.txBackOff_dB != null && message.hasOwnProperty("txBackOff_dB"))
                                    object.txBackOff_dB = message.txBackOff_dB;
                                if (message.rangeStep != null && message.hasOwnProperty("rangeStep"))
                                    object.rangeStep = options.json && !isFinite(message.rangeStep) ? String(message.rangeStep) : message.rangeStep;
                                if (message.dopplerStep != null && message.hasOwnProperty("dopplerStep"))
                                    object.dopplerStep = options.json && !isFinite(message.dopplerStep) ? String(message.dopplerStep) : message.dopplerStep;
                                if (message.intraframeOn != null && message.hasOwnProperty("intraframeOn"))
                                    object.intraframeOn = message.intraframeOn;
                                if (message.carrierFreq != null && message.hasOwnProperty("carrierFreq"))
                                    object.carrierFreq = options.json && !isFinite(message.carrierFreq) ? String(message.carrierFreq) : message.carrierFreq;
                                return object;
                            };
    
                            /**
                             * Converts this ChirpDescriptor to JSON.
                             * @function toJSON
                             * @memberof density.protocol.openarea.v1.Scene.ChirpDescriptor
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            ChirpDescriptor.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return ChirpDescriptor;
                        })();
    
                        return Scene;
                    })();
    
                    v1.Config = (function() {
    
                        /**
                         * Properties of a Config.
                         * @memberof density.protocol.openarea.v1
                         * @interface IConfig
                         * @property {string|null} [json] Config json
                         * @property {string|null} [version] Config version
                         */
    
                        /**
                         * Constructs a new Config.
                         * @memberof density.protocol.openarea.v1
                         * @classdesc Represents a Config.
                         * @implements IConfig
                         * @constructor
                         * @param {density.protocol.openarea.v1.IConfig=} [properties] Properties to set
                         */
                        function Config(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Config json.
                         * @member {string} json
                         * @memberof density.protocol.openarea.v1.Config
                         * @instance
                         */
                        Config.prototype.json = "";
    
                        /**
                         * Config version.
                         * @member {string} version
                         * @memberof density.protocol.openarea.v1.Config
                         * @instance
                         */
                        Config.prototype.version = "";
    
                        /**
                         * Creates a new Config instance using the specified properties.
                         * @function create
                         * @memberof density.protocol.openarea.v1.Config
                         * @static
                         * @param {density.protocol.openarea.v1.IConfig=} [properties] Properties to set
                         * @returns {density.protocol.openarea.v1.Config} Config instance
                         */
                        Config.create = function create(properties) {
                            return new Config(properties);
                        };
    
                        /**
                         * Encodes the specified Config message. Does not implicitly {@link density.protocol.openarea.v1.Config.verify|verify} messages.
                         * @function encode
                         * @memberof density.protocol.openarea.v1.Config
                         * @static
                         * @param {density.protocol.openarea.v1.IConfig} message Config message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Config.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.json != null && Object.hasOwnProperty.call(message, "json"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.json);
                            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.version);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Config message, length delimited. Does not implicitly {@link density.protocol.openarea.v1.Config.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof density.protocol.openarea.v1.Config
                         * @static
                         * @param {density.protocol.openarea.v1.IConfig} message Config message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Config.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Config message from the specified reader or buffer.
                         * @function decode
                         * @memberof density.protocol.openarea.v1.Config
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {density.protocol.openarea.v1.Config} Config
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Config.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.protocol.openarea.v1.Config();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.json = reader.string();
                                    break;
                                case 2:
                                    message.version = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Config message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof density.protocol.openarea.v1.Config
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {density.protocol.openarea.v1.Config} Config
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Config.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Config message.
                         * @function verify
                         * @memberof density.protocol.openarea.v1.Config
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Config.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.json != null && message.hasOwnProperty("json"))
                                if (!$util.isString(message.json))
                                    return "json: string expected";
                            if (message.version != null && message.hasOwnProperty("version"))
                                if (!$util.isString(message.version))
                                    return "version: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a Config message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof density.protocol.openarea.v1.Config
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {density.protocol.openarea.v1.Config} Config
                         */
                        Config.fromObject = function fromObject(object) {
                            if (object instanceof $root.density.protocol.openarea.v1.Config)
                                return object;
                            var message = new $root.density.protocol.openarea.v1.Config();
                            if (object.json != null)
                                message.json = String(object.json);
                            if (object.version != null)
                                message.version = String(object.version);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Config message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof density.protocol.openarea.v1.Config
                         * @static
                         * @param {density.protocol.openarea.v1.Config} message Config
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Config.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.json = "";
                                object.version = "";
                            }
                            if (message.json != null && message.hasOwnProperty("json"))
                                object.json = message.json;
                            if (message.version != null && message.hasOwnProperty("version"))
                                object.version = message.version;
                            return object;
                        };
    
                        /**
                         * Converts this Config to JSON.
                         * @function toJSON
                         * @memberof density.protocol.openarea.v1.Config
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Config.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Config;
                    })();
    
                    v1.SensorData = (function() {
    
                        /**
                         * Properties of a SensorData.
                         * @memberof density.protocol.openarea.v1
                         * @interface ISensorData
                         * @property {density.protocol.openarea.v1.IScene|null} [message_scene] SensorData message_scene
                         * @property {density.protocol.openarea.v1.IFrame|null} [message_frame] SensorData message_frame
                         * @property {density.protocol.openarea.v1.IConfig|null} [message_config] SensorData message_config
                         */
    
                        /**
                         * Constructs a new SensorData.
                         * @memberof density.protocol.openarea.v1
                         * @classdesc Represents a SensorData.
                         * @implements ISensorData
                         * @constructor
                         * @param {density.protocol.openarea.v1.ISensorData=} [properties] Properties to set
                         */
                        function SensorData(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * SensorData message_scene.
                         * @member {density.protocol.openarea.v1.IScene|null|undefined} message_scene
                         * @memberof density.protocol.openarea.v1.SensorData
                         * @instance
                         */
                        SensorData.prototype.message_scene = null;
    
                        /**
                         * SensorData message_frame.
                         * @member {density.protocol.openarea.v1.IFrame|null|undefined} message_frame
                         * @memberof density.protocol.openarea.v1.SensorData
                         * @instance
                         */
                        SensorData.prototype.message_frame = null;
    
                        /**
                         * SensorData message_config.
                         * @member {density.protocol.openarea.v1.IConfig|null|undefined} message_config
                         * @memberof density.protocol.openarea.v1.SensorData
                         * @instance
                         */
                        SensorData.prototype.message_config = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * SensorData sensordata.
                         * @member {"message_scene"|"message_frame"|"message_config"|undefined} sensordata
                         * @memberof density.protocol.openarea.v1.SensorData
                         * @instance
                         */
                        Object.defineProperty(SensorData.prototype, "sensordata", {
                            get: $util.oneOfGetter($oneOfFields = ["message_scene", "message_frame", "message_config"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new SensorData instance using the specified properties.
                         * @function create
                         * @memberof density.protocol.openarea.v1.SensorData
                         * @static
                         * @param {density.protocol.openarea.v1.ISensorData=} [properties] Properties to set
                         * @returns {density.protocol.openarea.v1.SensorData} SensorData instance
                         */
                        SensorData.create = function create(properties) {
                            return new SensorData(properties);
                        };
    
                        /**
                         * Encodes the specified SensorData message. Does not implicitly {@link density.protocol.openarea.v1.SensorData.verify|verify} messages.
                         * @function encode
                         * @memberof density.protocol.openarea.v1.SensorData
                         * @static
                         * @param {density.protocol.openarea.v1.ISensorData} message SensorData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SensorData.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.message_scene != null && Object.hasOwnProperty.call(message, "message_scene"))
                                $root.density.protocol.openarea.v1.Scene.encode(message.message_scene, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.message_frame != null && Object.hasOwnProperty.call(message, "message_frame"))
                                $root.density.protocol.openarea.v1.Frame.encode(message.message_frame, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            if (message.message_config != null && Object.hasOwnProperty.call(message, "message_config"))
                                $root.density.protocol.openarea.v1.Config.encode(message.message_config, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified SensorData message, length delimited. Does not implicitly {@link density.protocol.openarea.v1.SensorData.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof density.protocol.openarea.v1.SensorData
                         * @static
                         * @param {density.protocol.openarea.v1.ISensorData} message SensorData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SensorData.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a SensorData message from the specified reader or buffer.
                         * @function decode
                         * @memberof density.protocol.openarea.v1.SensorData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {density.protocol.openarea.v1.SensorData} SensorData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SensorData.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.protocol.openarea.v1.SensorData();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.message_scene = $root.density.protocol.openarea.v1.Scene.decode(reader, reader.uint32());
                                    break;
                                case 2:
                                    message.message_frame = $root.density.protocol.openarea.v1.Frame.decode(reader, reader.uint32());
                                    break;
                                case 3:
                                    message.message_config = $root.density.protocol.openarea.v1.Config.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a SensorData message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof density.protocol.openarea.v1.SensorData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {density.protocol.openarea.v1.SensorData} SensorData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SensorData.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a SensorData message.
                         * @function verify
                         * @memberof density.protocol.openarea.v1.SensorData
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        SensorData.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.message_scene != null && message.hasOwnProperty("message_scene")) {
                                properties.sensordata = 1;
                                {
                                    var error = $root.density.protocol.openarea.v1.Scene.verify(message.message_scene);
                                    if (error)
                                        return "message_scene." + error;
                                }
                            }
                            if (message.message_frame != null && message.hasOwnProperty("message_frame")) {
                                if (properties.sensordata === 1)
                                    return "sensordata: multiple values";
                                properties.sensordata = 1;
                                {
                                    var error = $root.density.protocol.openarea.v1.Frame.verify(message.message_frame);
                                    if (error)
                                        return "message_frame." + error;
                                }
                            }
                            if (message.message_config != null && message.hasOwnProperty("message_config")) {
                                if (properties.sensordata === 1)
                                    return "sensordata: multiple values";
                                properties.sensordata = 1;
                                {
                                    var error = $root.density.protocol.openarea.v1.Config.verify(message.message_config);
                                    if (error)
                                        return "message_config." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a SensorData message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof density.protocol.openarea.v1.SensorData
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {density.protocol.openarea.v1.SensorData} SensorData
                         */
                        SensorData.fromObject = function fromObject(object) {
                            if (object instanceof $root.density.protocol.openarea.v1.SensorData)
                                return object;
                            var message = new $root.density.protocol.openarea.v1.SensorData();
                            if (object.message_scene != null) {
                                if (typeof object.message_scene !== "object")
                                    throw TypeError(".density.protocol.openarea.v1.SensorData.message_scene: object expected");
                                message.message_scene = $root.density.protocol.openarea.v1.Scene.fromObject(object.message_scene);
                            }
                            if (object.message_frame != null) {
                                if (typeof object.message_frame !== "object")
                                    throw TypeError(".density.protocol.openarea.v1.SensorData.message_frame: object expected");
                                message.message_frame = $root.density.protocol.openarea.v1.Frame.fromObject(object.message_frame);
                            }
                            if (object.message_config != null) {
                                if (typeof object.message_config !== "object")
                                    throw TypeError(".density.protocol.openarea.v1.SensorData.message_config: object expected");
                                message.message_config = $root.density.protocol.openarea.v1.Config.fromObject(object.message_config);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a SensorData message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof density.protocol.openarea.v1.SensorData
                         * @static
                         * @param {density.protocol.openarea.v1.SensorData} message SensorData
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        SensorData.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (message.message_scene != null && message.hasOwnProperty("message_scene")) {
                                object.message_scene = $root.density.protocol.openarea.v1.Scene.toObject(message.message_scene, options);
                                if (options.oneofs)
                                    object.sensordata = "message_scene";
                            }
                            if (message.message_frame != null && message.hasOwnProperty("message_frame")) {
                                object.message_frame = $root.density.protocol.openarea.v1.Frame.toObject(message.message_frame, options);
                                if (options.oneofs)
                                    object.sensordata = "message_frame";
                            }
                            if (message.message_config != null && message.hasOwnProperty("message_config")) {
                                object.message_config = $root.density.protocol.openarea.v1.Config.toObject(message.message_config, options);
                                if (options.oneofs)
                                    object.sensordata = "message_config";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this SensorData to JSON.
                         * @function toJSON
                         * @memberof density.protocol.openarea.v1.SensorData
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        SensorData.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return SensorData;
                    })();
    
                    return v1;
                })();
    
                return openarea;
            })();
    
            return protocol;
        })();
    
        density.sensors = (function() {
    
            /**
             * Namespace sensors.
             * @memberof density
             * @namespace
             */
            var sensors = {};
    
            sensors.accelerometer = (function() {
    
                /**
                 * Namespace accelerometer.
                 * @memberof density.sensors
                 * @namespace
                 */
                var accelerometer = {};
    
                accelerometer.v1 = (function() {
    
                    /**
                     * Namespace v1.
                     * @memberof density.sensors.accelerometer
                     * @namespace
                     */
                    var v1 = {};
    
                    v1.Hardware = (function() {
    
                        /**
                         * Properties of a Hardware.
                         * @memberof density.sensors.accelerometer.v1
                         * @interface IHardware
                         * @property {string|null} [sensor_name] Hardware sensor_name
                         */
    
                        /**
                         * Constructs a new Hardware.
                         * @memberof density.sensors.accelerometer.v1
                         * @classdesc Represents a Hardware.
                         * @implements IHardware
                         * @constructor
                         * @param {density.sensors.accelerometer.v1.IHardware=} [properties] Properties to set
                         */
                        function Hardware(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Hardware sensor_name.
                         * @member {string} sensor_name
                         * @memberof density.sensors.accelerometer.v1.Hardware
                         * @instance
                         */
                        Hardware.prototype.sensor_name = "";
    
                        /**
                         * Creates a new Hardware instance using the specified properties.
                         * @function create
                         * @memberof density.sensors.accelerometer.v1.Hardware
                         * @static
                         * @param {density.sensors.accelerometer.v1.IHardware=} [properties] Properties to set
                         * @returns {density.sensors.accelerometer.v1.Hardware} Hardware instance
                         */
                        Hardware.create = function create(properties) {
                            return new Hardware(properties);
                        };
    
                        /**
                         * Encodes the specified Hardware message. Does not implicitly {@link density.sensors.accelerometer.v1.Hardware.verify|verify} messages.
                         * @function encode
                         * @memberof density.sensors.accelerometer.v1.Hardware
                         * @static
                         * @param {density.sensors.accelerometer.v1.IHardware} message Hardware message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Hardware.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.sensor_name != null && Object.hasOwnProperty.call(message, "sensor_name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.sensor_name);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Hardware message, length delimited. Does not implicitly {@link density.sensors.accelerometer.v1.Hardware.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof density.sensors.accelerometer.v1.Hardware
                         * @static
                         * @param {density.sensors.accelerometer.v1.IHardware} message Hardware message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Hardware.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Hardware message from the specified reader or buffer.
                         * @function decode
                         * @memberof density.sensors.accelerometer.v1.Hardware
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {density.sensors.accelerometer.v1.Hardware} Hardware
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Hardware.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.sensors.accelerometer.v1.Hardware();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.sensor_name = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Hardware message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof density.sensors.accelerometer.v1.Hardware
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {density.sensors.accelerometer.v1.Hardware} Hardware
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Hardware.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Hardware message.
                         * @function verify
                         * @memberof density.sensors.accelerometer.v1.Hardware
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Hardware.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.sensor_name != null && message.hasOwnProperty("sensor_name"))
                                if (!$util.isString(message.sensor_name))
                                    return "sensor_name: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a Hardware message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof density.sensors.accelerometer.v1.Hardware
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {density.sensors.accelerometer.v1.Hardware} Hardware
                         */
                        Hardware.fromObject = function fromObject(object) {
                            if (object instanceof $root.density.sensors.accelerometer.v1.Hardware)
                                return object;
                            var message = new $root.density.sensors.accelerometer.v1.Hardware();
                            if (object.sensor_name != null)
                                message.sensor_name = String(object.sensor_name);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Hardware message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof density.sensors.accelerometer.v1.Hardware
                         * @static
                         * @param {density.sensors.accelerometer.v1.Hardware} message Hardware
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Hardware.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.sensor_name = "";
                            if (message.sensor_name != null && message.hasOwnProperty("sensor_name"))
                                object.sensor_name = message.sensor_name;
                            return object;
                        };
    
                        /**
                         * Converts this Hardware to JSON.
                         * @function toJSON
                         * @memberof density.sensors.accelerometer.v1.Hardware
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Hardware.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Hardware;
                    })();
    
                    v1.Sample = (function() {
    
                        /**
                         * Properties of a Sample.
                         * @memberof density.sensors.accelerometer.v1
                         * @interface ISample
                         * @property {number|null} [sensor_range] Sample sensor_range
                         * @property {number|null} [sample_bits] Sample sample_bits
                         * @property {number|null} [sample_rate_hz] Sample sample_rate_hz
                         * @property {number|null} [sample_x] Sample sample_x
                         * @property {number|null} [sample_y] Sample sample_y
                         * @property {number|null} [sample_z] Sample sample_z
                         */
    
                        /**
                         * Constructs a new Sample.
                         * @memberof density.sensors.accelerometer.v1
                         * @classdesc Represents a Sample.
                         * @implements ISample
                         * @constructor
                         * @param {density.sensors.accelerometer.v1.ISample=} [properties] Properties to set
                         */
                        function Sample(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Sample sensor_range.
                         * @member {number} sensor_range
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @instance
                         */
                        Sample.prototype.sensor_range = 0;
    
                        /**
                         * Sample sample_bits.
                         * @member {number} sample_bits
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @instance
                         */
                        Sample.prototype.sample_bits = 0;
    
                        /**
                         * Sample sample_rate_hz.
                         * @member {number} sample_rate_hz
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @instance
                         */
                        Sample.prototype.sample_rate_hz = 0;
    
                        /**
                         * Sample sample_x.
                         * @member {number} sample_x
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @instance
                         */
                        Sample.prototype.sample_x = 0;
    
                        /**
                         * Sample sample_y.
                         * @member {number} sample_y
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @instance
                         */
                        Sample.prototype.sample_y = 0;
    
                        /**
                         * Sample sample_z.
                         * @member {number} sample_z
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @instance
                         */
                        Sample.prototype.sample_z = 0;
    
                        /**
                         * Creates a new Sample instance using the specified properties.
                         * @function create
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @static
                         * @param {density.sensors.accelerometer.v1.ISample=} [properties] Properties to set
                         * @returns {density.sensors.accelerometer.v1.Sample} Sample instance
                         */
                        Sample.create = function create(properties) {
                            return new Sample(properties);
                        };
    
                        /**
                         * Encodes the specified Sample message. Does not implicitly {@link density.sensors.accelerometer.v1.Sample.verify|verify} messages.
                         * @function encode
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @static
                         * @param {density.sensors.accelerometer.v1.ISample} message Sample message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Sample.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.sensor_range != null && Object.hasOwnProperty.call(message, "sensor_range"))
                                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.sensor_range);
                            if (message.sample_bits != null && Object.hasOwnProperty.call(message, "sample_bits"))
                                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.sample_bits);
                            if (message.sample_rate_hz != null && Object.hasOwnProperty.call(message, "sample_rate_hz"))
                                writer.uint32(/* id 3, wireType 1 =*/25).double(message.sample_rate_hz);
                            if (message.sample_x != null && Object.hasOwnProperty.call(message, "sample_x"))
                                writer.uint32(/* id 4, wireType 1 =*/33).double(message.sample_x);
                            if (message.sample_y != null && Object.hasOwnProperty.call(message, "sample_y"))
                                writer.uint32(/* id 5, wireType 1 =*/41).double(message.sample_y);
                            if (message.sample_z != null && Object.hasOwnProperty.call(message, "sample_z"))
                                writer.uint32(/* id 6, wireType 1 =*/49).double(message.sample_z);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Sample message, length delimited. Does not implicitly {@link density.sensors.accelerometer.v1.Sample.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @static
                         * @param {density.sensors.accelerometer.v1.ISample} message Sample message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Sample.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Sample message from the specified reader or buffer.
                         * @function decode
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {density.sensors.accelerometer.v1.Sample} Sample
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Sample.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.sensors.accelerometer.v1.Sample();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.sensor_range = reader.uint32();
                                    break;
                                case 2:
                                    message.sample_bits = reader.uint32();
                                    break;
                                case 3:
                                    message.sample_rate_hz = reader.double();
                                    break;
                                case 4:
                                    message.sample_x = reader.double();
                                    break;
                                case 5:
                                    message.sample_y = reader.double();
                                    break;
                                case 6:
                                    message.sample_z = reader.double();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Sample message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {density.sensors.accelerometer.v1.Sample} Sample
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Sample.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Sample message.
                         * @function verify
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Sample.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.sensor_range != null && message.hasOwnProperty("sensor_range"))
                                if (!$util.isInteger(message.sensor_range))
                                    return "sensor_range: integer expected";
                            if (message.sample_bits != null && message.hasOwnProperty("sample_bits"))
                                if (!$util.isInteger(message.sample_bits))
                                    return "sample_bits: integer expected";
                            if (message.sample_rate_hz != null && message.hasOwnProperty("sample_rate_hz"))
                                if (typeof message.sample_rate_hz !== "number")
                                    return "sample_rate_hz: number expected";
                            if (message.sample_x != null && message.hasOwnProperty("sample_x"))
                                if (typeof message.sample_x !== "number")
                                    return "sample_x: number expected";
                            if (message.sample_y != null && message.hasOwnProperty("sample_y"))
                                if (typeof message.sample_y !== "number")
                                    return "sample_y: number expected";
                            if (message.sample_z != null && message.hasOwnProperty("sample_z"))
                                if (typeof message.sample_z !== "number")
                                    return "sample_z: number expected";
                            return null;
                        };
    
                        /**
                         * Creates a Sample message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {density.sensors.accelerometer.v1.Sample} Sample
                         */
                        Sample.fromObject = function fromObject(object) {
                            if (object instanceof $root.density.sensors.accelerometer.v1.Sample)
                                return object;
                            var message = new $root.density.sensors.accelerometer.v1.Sample();
                            if (object.sensor_range != null)
                                message.sensor_range = object.sensor_range >>> 0;
                            if (object.sample_bits != null)
                                message.sample_bits = object.sample_bits >>> 0;
                            if (object.sample_rate_hz != null)
                                message.sample_rate_hz = Number(object.sample_rate_hz);
                            if (object.sample_x != null)
                                message.sample_x = Number(object.sample_x);
                            if (object.sample_y != null)
                                message.sample_y = Number(object.sample_y);
                            if (object.sample_z != null)
                                message.sample_z = Number(object.sample_z);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Sample message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @static
                         * @param {density.sensors.accelerometer.v1.Sample} message Sample
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Sample.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.sensor_range = 0;
                                object.sample_bits = 0;
                                object.sample_rate_hz = 0;
                                object.sample_x = 0;
                                object.sample_y = 0;
                                object.sample_z = 0;
                            }
                            if (message.sensor_range != null && message.hasOwnProperty("sensor_range"))
                                object.sensor_range = message.sensor_range;
                            if (message.sample_bits != null && message.hasOwnProperty("sample_bits"))
                                object.sample_bits = message.sample_bits;
                            if (message.sample_rate_hz != null && message.hasOwnProperty("sample_rate_hz"))
                                object.sample_rate_hz = options.json && !isFinite(message.sample_rate_hz) ? String(message.sample_rate_hz) : message.sample_rate_hz;
                            if (message.sample_x != null && message.hasOwnProperty("sample_x"))
                                object.sample_x = options.json && !isFinite(message.sample_x) ? String(message.sample_x) : message.sample_x;
                            if (message.sample_y != null && message.hasOwnProperty("sample_y"))
                                object.sample_y = options.json && !isFinite(message.sample_y) ? String(message.sample_y) : message.sample_y;
                            if (message.sample_z != null && message.hasOwnProperty("sample_z"))
                                object.sample_z = options.json && !isFinite(message.sample_z) ? String(message.sample_z) : message.sample_z;
                            return object;
                        };
    
                        /**
                         * Converts this Sample to JSON.
                         * @function toJSON
                         * @memberof density.sensors.accelerometer.v1.Sample
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Sample.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Sample;
                    })();
    
                    v1.AccelerometerData = (function() {
    
                        /**
                         * Properties of an AccelerometerData.
                         * @memberof density.sensors.accelerometer.v1
                         * @interface IAccelerometerData
                         * @property {density.sensors.accelerometer.v1.ISample|null} [message_sample] AccelerometerData message_sample
                         * @property {density.sensors.accelerometer.v1.IHardware|null} [message_hardware] AccelerometerData message_hardware
                         */
    
                        /**
                         * Constructs a new AccelerometerData.
                         * @memberof density.sensors.accelerometer.v1
                         * @classdesc Represents an AccelerometerData.
                         * @implements IAccelerometerData
                         * @constructor
                         * @param {density.sensors.accelerometer.v1.IAccelerometerData=} [properties] Properties to set
                         */
                        function AccelerometerData(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * AccelerometerData message_sample.
                         * @member {density.sensors.accelerometer.v1.ISample|null|undefined} message_sample
                         * @memberof density.sensors.accelerometer.v1.AccelerometerData
                         * @instance
                         */
                        AccelerometerData.prototype.message_sample = null;
    
                        /**
                         * AccelerometerData message_hardware.
                         * @member {density.sensors.accelerometer.v1.IHardware|null|undefined} message_hardware
                         * @memberof density.sensors.accelerometer.v1.AccelerometerData
                         * @instance
                         */
                        AccelerometerData.prototype.message_hardware = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * AccelerometerData accelerometerdata.
                         * @member {"message_sample"|"message_hardware"|undefined} accelerometerdata
                         * @memberof density.sensors.accelerometer.v1.AccelerometerData
                         * @instance
                         */
                        Object.defineProperty(AccelerometerData.prototype, "accelerometerdata", {
                            get: $util.oneOfGetter($oneOfFields = ["message_sample", "message_hardware"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new AccelerometerData instance using the specified properties.
                         * @function create
                         * @memberof density.sensors.accelerometer.v1.AccelerometerData
                         * @static
                         * @param {density.sensors.accelerometer.v1.IAccelerometerData=} [properties] Properties to set
                         * @returns {density.sensors.accelerometer.v1.AccelerometerData} AccelerometerData instance
                         */
                        AccelerometerData.create = function create(properties) {
                            return new AccelerometerData(properties);
                        };
    
                        /**
                         * Encodes the specified AccelerometerData message. Does not implicitly {@link density.sensors.accelerometer.v1.AccelerometerData.verify|verify} messages.
                         * @function encode
                         * @memberof density.sensors.accelerometer.v1.AccelerometerData
                         * @static
                         * @param {density.sensors.accelerometer.v1.IAccelerometerData} message AccelerometerData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AccelerometerData.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.message_sample != null && Object.hasOwnProperty.call(message, "message_sample"))
                                $root.density.sensors.accelerometer.v1.Sample.encode(message.message_sample, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.message_hardware != null && Object.hasOwnProperty.call(message, "message_hardware"))
                                $root.density.sensors.accelerometer.v1.Hardware.encode(message.message_hardware, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified AccelerometerData message, length delimited. Does not implicitly {@link density.sensors.accelerometer.v1.AccelerometerData.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof density.sensors.accelerometer.v1.AccelerometerData
                         * @static
                         * @param {density.sensors.accelerometer.v1.IAccelerometerData} message AccelerometerData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AccelerometerData.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an AccelerometerData message from the specified reader or buffer.
                         * @function decode
                         * @memberof density.sensors.accelerometer.v1.AccelerometerData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {density.sensors.accelerometer.v1.AccelerometerData} AccelerometerData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AccelerometerData.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.density.sensors.accelerometer.v1.AccelerometerData();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.message_sample = $root.density.sensors.accelerometer.v1.Sample.decode(reader, reader.uint32());
                                    break;
                                case 2:
                                    message.message_hardware = $root.density.sensors.accelerometer.v1.Hardware.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an AccelerometerData message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof density.sensors.accelerometer.v1.AccelerometerData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {density.sensors.accelerometer.v1.AccelerometerData} AccelerometerData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AccelerometerData.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an AccelerometerData message.
                         * @function verify
                         * @memberof density.sensors.accelerometer.v1.AccelerometerData
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        AccelerometerData.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.message_sample != null && message.hasOwnProperty("message_sample")) {
                                properties.accelerometerdata = 1;
                                {
                                    var error = $root.density.sensors.accelerometer.v1.Sample.verify(message.message_sample);
                                    if (error)
                                        return "message_sample." + error;
                                }
                            }
                            if (message.message_hardware != null && message.hasOwnProperty("message_hardware")) {
                                if (properties.accelerometerdata === 1)
                                    return "accelerometerdata: multiple values";
                                properties.accelerometerdata = 1;
                                {
                                    var error = $root.density.sensors.accelerometer.v1.Hardware.verify(message.message_hardware);
                                    if (error)
                                        return "message_hardware." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates an AccelerometerData message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof density.sensors.accelerometer.v1.AccelerometerData
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {density.sensors.accelerometer.v1.AccelerometerData} AccelerometerData
                         */
                        AccelerometerData.fromObject = function fromObject(object) {
                            if (object instanceof $root.density.sensors.accelerometer.v1.AccelerometerData)
                                return object;
                            var message = new $root.density.sensors.accelerometer.v1.AccelerometerData();
                            if (object.message_sample != null) {
                                if (typeof object.message_sample !== "object")
                                    throw TypeError(".density.sensors.accelerometer.v1.AccelerometerData.message_sample: object expected");
                                message.message_sample = $root.density.sensors.accelerometer.v1.Sample.fromObject(object.message_sample);
                            }
                            if (object.message_hardware != null) {
                                if (typeof object.message_hardware !== "object")
                                    throw TypeError(".density.sensors.accelerometer.v1.AccelerometerData.message_hardware: object expected");
                                message.message_hardware = $root.density.sensors.accelerometer.v1.Hardware.fromObject(object.message_hardware);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an AccelerometerData message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof density.sensors.accelerometer.v1.AccelerometerData
                         * @static
                         * @param {density.sensors.accelerometer.v1.AccelerometerData} message AccelerometerData
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        AccelerometerData.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (message.message_sample != null && message.hasOwnProperty("message_sample")) {
                                object.message_sample = $root.density.sensors.accelerometer.v1.Sample.toObject(message.message_sample, options);
                                if (options.oneofs)
                                    object.accelerometerdata = "message_sample";
                            }
                            if (message.message_hardware != null && message.hasOwnProperty("message_hardware")) {
                                object.message_hardware = $root.density.sensors.accelerometer.v1.Hardware.toObject(message.message_hardware, options);
                                if (options.oneofs)
                                    object.accelerometerdata = "message_hardware";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this AccelerometerData to JSON.
                         * @function toJSON
                         * @memberof density.sensors.accelerometer.v1.AccelerometerData
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        AccelerometerData.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return AccelerometerData;
                    })();
    
                    return v1;
                })();
    
                return accelerometer;
            })();
    
            return sensors;
        })();
    
        return density;
    })();

    return $root;
});
